<template lang="pug">
.wrapper.container.product
    base-breadcrumbs(v-if="routeObj.length" :routeObj="routeObj").q-mt-sm
    .container(v-if="product").relative-position
        .row.q-mt-md.anchors-top.justify-between
            template(v-for="item in anchorLinks")
                .row.cursor-pointer(@click="scrollTo(item.value)" v-if="item.condition")
                    q-icon.q-mr-sm(
                        :name="`etabl:prod-${item.value}`"
                        size="24px"
                        color="grey-9"
                    )
                    .font-16.text-primary.text-weight-semi_medium
                        | {{ item.label }}
        .q-pt-lg#overall.relative-position
            .row.bg-secondary.b-radius-16.q-pa-md.q-mt-md.relative-position.justify-between
                .absolute-top-left.custom-a-top-left
                    .q-px-sm.q-py-xs.text-white.font-12.text-weight-regular.b-radius-16(
                        v-if="product.discount800 || product.discount300 || (product.priceCrossed > 0 && !notAvailable  )"
                        :class="promotionNameplate"
                    )
                        //div(v-if="product.discount800" ) Скидка -800 ₽ при покупке 2х упаковок
                        //div(v-if="product.discount300" ) Скидка -300 ₽ при покупке 2х упаковок
                        div(v-if="product?.advertisment_info?.length && product?.advertisment_info[0]?.title_short")
                            | {{product?.advertisment_info[0]?.title_short}}
                        div(v-else-if="product?.productActivities?.length" ) {{product?.productActivities[0]}}
                        div(v-else-if="product?.advertismentTitles?.length" ) {{product?.advertismentTitles[0]}}
                        div(v-else ) Акция
                        //base-tooltip(
                        //    v-if="product.discount800 || product.discount300"
                        //    title="Акция действительна только в розничной сети аптек «Табле.Точка»"
                        //    :maxWidth="'250px'"
                        //    :offset="[ 14, 14 ]"
                        //    anchor="top middle"
                        //    self="bottom middle"
                        //)
                        //base-tooltip(
                        //    v-if="product.discount800 || product.discount300"
                        //    title="Акция действительна только в розничной сети аптек «Табле.Точка»"
                        //    :maxWidth="'250px'"
                        //    :offset="[ 14, 14 ]"
                        //    anchor="top middle"
                        //    self="bottom middle"
                        //)
                //.share
                //    .flex.justify-end.cursor-pointer
                //        q-icon(
                //            name="etabl:share"
                //            color="positive"
                //            size="24px"
                //            @click="showShares = !showShares"
                //        )
                //    q-card.bg-secondary.b-radius-16.flex.column.q-px-md.q-pa-md(v-if="showShares")
                //        q-icon.absolute-top-right.q-pa-sm.cursor-pointer(
                //            name="etabl:cross"
                //            size="18px"
                //            color="primary"
                //            @click="showShares = false"
                //        )
                //        template(v-for="share in shares")
                //            a.row.link.q-mb-md(:href="share.link" target="_blank" @click="showShares = false")
                //                q-icon(
                //                    :name="`etabl:${share.icon}`"
                //                    size="20px"
                //                    color="grey-9"
                //                )
                //                .line-height-20.text-positive.q-ml-sm
                //                    | {{ share.title }}
                //        .row.cursor-pointer(@click="copy")
                //            q-icon(
                //                name="etabl:copy-round"
                //                size="20px"
                //                color="grey-9"
                //            )
                //            .line-height-20.text-positive.q-ml-sm
                //                | Скопировать ссылку

                //.flex.column(style="display:none")

                .q-pr-lg(
                    :class="isActivAccessibility ? 'col-0' : 'col-4'"
                    style="max-width: 400px"

                )
                    .row
                        //q-icon.q-mt-xs.q-mr-xs(
                        //    v-if="product.isMarker"
                        //    name="etabl:side-sale"
                        //    size="22px"
                        //    color="negative")
                        //    base-tooltip(title="Скидка")
                    div.card-product__disable(
                        v-if="notAvailable"
                        :style="`height: ${imgHeight}px`"
                    )
                    .relative-position.card-product__img.q-mt-lg.flex.column.justify-evenly.full-height
                        img(:src="product.previewImage"
                            @click="openImg = true"
                            :alt="`${product.name} ${ product.subtitleShort } (${ product.manufacture }, ${ product.country })`"
                            :title="`${product.name} ${ product.subtitleShort } (${ product.manufacture }, ${ product.country })`").cursor-pointer
                        div(v-if="!isActivAccessibility")
                            | Фотографии представлены в ознакомительных целях
                            br
                            | Внешний вид товара может отличаться от изображенного на фотографии
                        //div
                        //    .text-positive.q-mb-sm.q-mt-md(style="font-size: 18px !important; font-weight: 700 !important") В копмлекте выгоднее!
                        //    p(style="font-size: 13px; color: #242424 !important; margin-bottom: 0") Купите 2 товара и получите скидку на оба
                        //.row.bg-secondary.b-radius-16.q-px-sm.cursor-pointer.q-mb-md.q-mt-sm(style="max-width: 178px; max-height: 172px; box-shadow: 2px 2px 10px 0px #9999991A; padding-top: 12.5px; padding-bottom: 12.5px")
                        //    img(:src="product.previewImage" style="max-height: 97px !important")
                        //    .q-mb-sm(style="color: #242424 !important") Но-шпа табл. п.п.о. 100 мг N100...длинное название
                        //    .text-positive(style="font-size: 16px !important; font-weight: 700 !important") от 799.0 ₽
                .row.column.col-9(style="max-width: 864px;row-gap: 24px")
                    .row.justify-between.full-width(style="max-height: 72px")
                        h1.product__title.text-primary.q-ma-none.text-weight-bold(
                            :style="fixedMenu ? `margin-bottom: ${containerOffset}px;` : ''"
                            :class="!notAvailable ? 'font-24' : ''") {{ product.name }} {{ product.subtitleShort }} ({{ product.manufacture }}, {{ product.country }})
                        .row.justify-between.items-start(style="gap: 8px")
                            .flex.justify-end.cursor-pointer
                                q-icon(
                                    name="etabl:share"
                                    color="positive"
                                    size="24px"
                                    @click="showShares = !showShares"
                                )
                                .share
                                    q-card.bg-secondary.b-radius-16.flex.column.q-px-md.q-pa-md(v-if="showShares")
                                        q-icon.absolute-top-right.q-pa-sm.cursor-pointer(
                                            name="etabl:cross"
                                            size="18px"
                                            color="primary"
                                            @click="showShares = false"
                                        )
                                        template(v-for="share in shares")
                                            a.row.link.q-mb-md(:href="share.link" target="_blank" @click="showShares = false")
                                                q-icon(
                                                    :name="`etabl:${share.icon}`"
                                                    size="20px"
                                                    color="grey-9"
                                                )
                                                .line-height-20.text-positive.q-ml-sm
                                                    | {{ share.title }}
                                        .row.cursor-pointer(@click="copy")
                                            q-icon(
                                                name="etabl:copy-round"
                                                size="20px"
                                                color="grey-9"
                                            )
                                            .line-height-20.text-positive.q-ml-sm
                                                | Скопировать ссылку



                            .cursor-pointer.row.items-center.justify-center.fav-button(
                                @click.prevent.default="updateFavourite"
                            )
                                q-icon(
                                    name="favorite_border"
                                    size="24px"
                                    :color="isFavourite ? 'negative' : 'grey-7'")
                                    base-tooltip(title="В избранное")

                    .row.no-wrap
                        div(
                            :class="isActivAccessibility ? 'col-12' : 'col-8'"
                            :style="isActivAccessibility ? {} : { 'max-width': '553px' }"
                        )

                            template(v-if="product.productPackages")
                                .text-weight-medium.text-primary
                                    | Количество:
                                .row.q-mt-sm.text-primary
                                    .package-form.q-px-lg.q-pb-sm.b-radius-16.q-mr-md.cursor-pointer.q-mb-md(
                                        v-for="item in product.productPackages"
                                        @click="goTo(item.url)"
                                        :class="item.is_checked ? 'active-form' : ''")
                                        .font-18.line-height-18
                                            | {{ item.number }}
                            template(v-if="product.productDoses")
                                .text-weight-medium
                                    |  Дозировка:
                                .row.q-mt-sm
                                    .package-form.q-px-lg.q-pb-sm.b-radius-16.q-mr-md.cursor-pointer.q-mb-md(
                                        v-for="item in product.productDoses"
                                        @click="goTo(item.url)"
                                        :class="item.is_checked ? 'active-form' : ''")
                                        .font-18.line-height-18
                                            | {{ item.number }}
                            template(v-if="product.productSizes")
                                .text-weight-medium
                                    |  Размеры:
                                .row.q-mt-sm
                                    .package-form.q-px-lg.q-pb-sm.b-radius-16.q-mr-md.cursor-pointer.q-mb-md(
                                        v-for="item in product.productSizes"
                                        @click="goTo(item.url)"
                                        :class="item.is_checked ? 'active-form' : ''")
                                        .font-18.line-height-18
                                            | {{ item.number }}
                            .full-width.no-wrap.row.justify-start.items-center(v-if="product.isPrescription" :class="product.productPackages || product.productDoses || product.productSizes  ? '' : 'q-mt-md'")
                                q-icon.q-mr-md(
                                    v-if="!product.isErp"
                                    name="img:rx.svg"
                                    size="24px")
                                q-icon.q-mr-md(
                                    v-else
                                    name="img:rx_e.svg"
                                    size="24px")
                                span.cursor-pointer.hover-color-blue-14(v-if="!product.isErp" @click="showPrecriptionTooltip = !showPrecriptionTooltip") Рецептурный препарат
                                    .relative-position
                                        q-card.bg-secondary.b-radius-8.q-pa-md.erp-card.text-left.font-12.text-primary.line-height-16(v-if="showPrecriptionTooltip")
                                            .row.items-center
                                                q-icon(
                                                    name="img:rx.svg"
                                                    size="24px").q-mr-sm
                                                .font-14.line-height-20.text-weight-medium
                                                    | Этот препарат является рецептурным
                                            .q-mt-sm
                                                | Вы можете заказать его на сайте, но при получении в аптеке потребуется предъявить рецепт.
                                            .q-mt-xs.q-mb-sm
                                                | Без рецепта фармацевт может отказать в продаже, согласно правилам отпуска лекарственных средств.
                                            base-btn(
                                                label="Понятно"
                                                height="40"
                                                width="304"
                                                @click.prevent.stop="showPrecriptionTooltip = false"
                                                font_size="16"
                                                bradius="16"
                                                loading_color="secondary")
                                span(v-if="product.isErp") Доставка по электронному рецепту
                                q-icon(
                                    v-if="product.isErp"
                                    @click="showErpTooltip = !showErpTooltip"
                                    name="etabl:question"
                                    size="16px"
                                    :color="showErpTooltip ? 'positive' : 'grey-9'").q-ml-sm
                                .relative-position
                                    q-card.bg-secondary.b-radius-8.q-px-md.q-py-sm.erp-card.text-left.font-12.text-primary.line-height-16(v-if="showErpTooltip" style="left: -190px; width: 384px")
                                        | Жителям Белгородской области теперь доступна доставка <br> курьером выписанных по электронному рецепту лекарств.
                                        .text-weight-medium.q-mb-sm
                                            | Узнайте больше об этой услуге
                                            span.q-mt-sm.text-positive.cursor-pointer(
                                                style="text-decoration: underline;"
                                                @click="openWindow('/policy')")
                                                | «Электоронные рецепты»
                                        .text-positive.cursor-pointer(
                                            style="text-decoration: underline;"
                                            @click="openWindow('/how-to-order?isErp=true')")
                                            | Как сделать заказ по электронному рецепту
                            .full-width.no-wrap.row.justify-start.items-center.q-mt-md(v-if="product.cold")
                                q-icon.q-mr-md(
                                    name="etabl:frost"
                                    size="24px"
                                    color="light-blue")
                                span.cursor-pointer.hover-color-blue-14(@click="showTermoTooltip = !showTermoTooltip") Термолабильный препарат
                                    .relative-position
                                        q-card.bg-secondary.b-radius-8.q-pa-md.erp-card.text-left.font-12.text-primary.line-height-16(v-if="showTermoTooltip")
                                            .row.items-center
                                                q-icon(
                                                    name="etabl:frost"
                                                    size="24px"
                                                    color="light-blue").q-mr-sm
                                                .font-14.line-height-20.text-weight-medium
                                                    | Условия хранения
                                            .q-my-sm
                                                | {{ termoText }}
                                            base-btn(
                                                label="Понятно"
                                                height="40"
                                                width="304"
                                                @click.prevent.stop="showTermoTooltip = false"
                                                font_size="16"
                                                bradius="16"
                                                loading_color="secondary")
                            .full-width.no-wrap.row.justify-start.items-center.q-mt-md(v-if="product.truCode")
                                q-icon.q-mr-md(
                                    name="img:fss.svg"
                                    size="24px"
                                    color="light-blue")
                                span Оплата с помощью сертификата ФСС
                            .row.card-product.q-mt-md
                                .full-width.row.justify-between.font-14
                                    .full-width.items-start.card-product__characteristics-info
                                        .row.justify-between.full-width
                                            span.text-grey-9 Страна производитель
                                            .row
                                                span {{ product.country }}
                                                q-icon(
                                                    name="etabl:question"
                                                    size="16px"
                                                    color="grey-9").q-ml-sm
                                                    base-tooltip(tooltip300 :offset="[ 10, -90]" title="Страна производства может отличаться от указанной на сайте. Проверяйте, пожалуйста, при получении заказа")
                                        q-separator.full-width.q-mt-sm(color="green-7")
                                    .full-width.row.justify-between.items-start.card-product__characteristics-info
                                        span Производитель
                                        span.justify-end
                                            router-link.link(
                                                :to="`/search?query=${product.manufacture}&noTerm=true&limit=20&manufacture.raw=${product.manufacture}`") &nbsp;{{ product.manufacture }}
                                                q-icon(
                                                    @click.prevent.stop = ""
                                                    name="etabl:question"
                                                    size="16px"
                                                    color="grey-9").q-ml-sm
                                                    base-tooltip(tooltip300 :offset="[ 10, -90]" title="Производитель может отличаться от указанного на сайте. Проверяйте, пожалуйста, при получении заказа")
                                        q-separator.full-width.q-mt-sm(color="green-7")
                                    .full-width.row.justify-between.items-start.card-product__characteristics-info
                                        span Общее описание
                                        span.text-right {{ product.type }}
                                        q-separator.full-width.q-mt-sm(color="green-7")
                                    .full-width.row.justify-between.items-start.card-product__characteristics-info(v-if="product.packing_form")
                                        span Форма выпуска
                                        span.text-right {{ product.packingForm }}
                                        q-separator.full-width.q-mt-sm(color="green-7")
                                    .full-width.row.justify-between.items-start.card-product__characteristics-info(v-if="product.number[0]")
                                        span Количество в упаковке
                                        span.text-right {{ product.number[0] }}
                                        q-separator.full-width.q-mt-sm(color="green-7")
                                    .full-width.row.justify-between.items-start.card-product__characteristics-info(
                                        v-if="product.type === 'Лекарственные средства' && product?.mnn?.length > 0 && product.mnn[0] ")
                                        span Действующее вещество
                                        span.justify-end
                                            router-link.link(
                                                v-for="(link, i) in product.mnn"
                                                :to="`/search?query=${link}&noTerm=true&limit=20`") &nbsp;{{ link }}{{ i < product.mnn.length - 1 ? ',' : '' }}
                                        q-separator.full-width.q-mt-sm(color="green-7")
                                    .full-width.row.justify-between.items-start.card-product__characteristics-info(
                                        v-if="(product.groupCategory.code == '000000288' || product.groupCategory.code == '000000199' || product.groupCategory.code == '000000252' || product.groupCategory.code == '000000346') && product.brand")
                                        .text-primary Бренд
                                        .justify-end
                                            router-link.link(
                                                :to="`/search?query=${product.brand}&noTerm=true&limit=20`") &nbsp;{{ product.brand }}
                                        q-separator.full-width.q-mt-sm(color="green-7")
                            //.row.items-center(v-if="!notAvailable")
                            //    .font-24.text-weight-medium.text-primary.q-mr-lg
                            //        | Цена
                            //    template(v-if="product.isMarker && salePercent > 0")
                            //        span.q-mr-sm.text-positive.font-16.text-weight-medium(
                            //            style="text-decoration: line-through;")
                            //            | {{ new Intl.NumberFormat('ru-RU').format(product.priceCrossed) }}
                            //            span &nbsp;₽
                            //        .sale.q-mr-sm.q-px-sm.q-py-xs.b-radius-16.border-negative.flex.items-center
                            //            .font-12.line-height-16.text-negative
                            //                | {{ salePercent }}%
                            //        span.text-weight-bold.font-24.text-positive.q-ml-xs
                            //            | {{ new Intl.NumberFormat('ru-RU').format(product.price) }}
                            //            span &nbsp;₽
                            //    template(v-else-if="product.isMarker" )
                            //        span.text-weight-bold.font-24.text-positive
                            //            | {{ new Intl.NumberFormat('ru-RU').format(product.price) }}
                            //            span &nbsp;₽
                            //    template(v-else)
                            //        span.text-weight-bold.font-24.text-positive
                            //            | от {{ new Intl.NumberFormat('ru-RU').format(product.price) }}
                            //            span &nbsp;₽
                                // q-icon.q-ml-xl(
                                //     v-if="delivery && !freeDelivery && (product.qDs || product.isPreorder)"
                                //     name="etabl:car_delivery"
                                //     size="26px"
                                //     color="grey-9")
                                //     base-tooltip(title="Возможна доставка на дом")
                                q-icon.q-ml-xl(
                                    v-if="freeDelivery && (product.qDs || product.isPreorder)"
                                    //:name="product.delivery == 1 ? 'etabl:delivery_one' : 'etabl:delivery_two'"
                                    //size="26px"
                                    //:color="product.delivery == 1 ? 'positive' : 'deep-purple-6'")
                                    //base-tooltip(:title="product.delivery == 1 ? 'Бесплатная доставка' : 'Бесплатная доставка при заказе от 2 товаров'")
                            //.row.q-mt-lg
                                //.cursor-pointer.row.items-center.justify-center.q-pa-sm.q-mr-lg.fav-button(
                                //    @click.prevent.default="updateFavourite")
                                //    q-icon(
                                //        name="favorite_border"
                                //        size="sm"
                                //        :color="isFavourite ? 'negative' : 'grey-7'")
                                //        base-tooltip(title="В избранное")
                                //q-no-ssr
                                //    template(v-if="notAvailable")
                                //        base-btn(
                                //            color="accent"
                                //            text_color="positive"
                                //            label="Нет в наличии"
                                //            height="40"
                                //            :width="windowWidth >= 1280 ? 230 : 190"
                                //            font_size="16"
                                //            bradius="20"
                                //            :loading="loading"
                                //            :disable="loading"
                                //            loading_color="secondary").product__add-to-cart
                                //    template(v-else)
                                //        base-btn(
                                //            color="accent"
                                //            text_color="positive"
                                //            label="Только в аптеке"
                                //            height="40"
                                //            :width="windowWidth >= 1280 ? 230 : 190"
                                //            font_size="16"
                                //            bradius="20"
                                //            :loading="loading"
                                //            :disable="loading"
                                //            loading_color="secondary"
                                //            v-if="product.limit === 0 || product.pku").product__add-to-cart
                                //        template(v-else)
                                //            base-btn(
                                //                label="В корзину"
                                //                height="40"
                                //                :width="windowWidth >= 1280 ? 230 : 190"
                                //                @click="addToCart"
                                //                font_size="16"
                                //                bradius="20"
                                //                :loading="loading"
                                //                :disable="loading"
                                //                loading_color="secondary"
                                //                v-if="!inCart").product__add-to-cart
                                //            button.row.items-center.justify-between.product__amount.product__add-to-cart.cursor-pointer(
                                //                :style="windowWidth >= 1280 ? 'width: 230px' : 'width: 190px'"
                                //                v-else
                                //                @click.stop="goToCart")
                                //                span Оформить
                                //                .row.justify-end.product__counter
                                //                    q-btn.justify-center.items-center.product__button.product__button-min.cursor-pointer.font-18.text-positive(
                                //                        unelevated
                                //                        rounded
                                //                        @click.stop="setAmount(0)") &ndash;
                                //                    .row.justify-center.items-center.product__count.font-18.text-weight-medium.text-positive {{ amount }}
                                //                    q-btn.justify-center.items-center.product__button.product__button-plus.cursor-pointer.font-18.text-positive(
                                //                        v-if="!preventAmoutUp"
                                //                        unelevated
                                //                        rounded
                                //                        @click.stop="setAmount(1)") +
                                //                    q-btn.justify-center.items-center.product__button.product__button__disable.cursor-pointer.font-18(
                                //                        v-else
                                //                        unelevated
                                //                        rounded
                                //                        @click.stop="") +
                                //                        base-tooltip(
                                //                            style="max-width: 300px;"
                                //                            title="Количество ограничено")
                                //        base-btn(
                                //            v-if="!product.pku"
                                //            color="secondary"
                                //            text_color="blue-12"
                                //            label="Покупка в 1 клик"
                                //            height="40"
                                //            :width="windowWidth >= 1280 ? 230 : 190"
                                //            font_size="16"
                                //            bradius="20"
                                //            @click="fastBuy"
                                //            :loading="loading"
                                //            :disable="loading"
                                //            loading_color="secondary"
                                //            border="1px solid #2D8BB2"
                                //            style="margin-left: 24px !important;").product__add-to-cart.q-ml-lg
                                //template(v-if="notAvailable")
                                //    .text-weight-medium.text-primary.flex.items-center.q-ml-xl.q-mr-lg
                                //        | Уведомить о поступлении
                                //    q-toggle(
                                //        v-model="subscribe"
                                //        color="positive"
                                //    )
                            //q-separator.full-width.q-mt-lg(color="green-7")
                            template(v-if="!notAvailable && product.limit != 0")
                                .font-24.q-mt-sm.text-weight-bold.q-mb-md.text-primary Оплата и способы получения:
                                .row
                                    .row.column.full-width(v-if="!product.pku || product.qDs")
                                        .row.items-center.q-mt-sm(v-if="product.qDs")
                                            q-icon(
                                                name="etabl:completed"
                                                size="24px"
                                                color="positive")
                                            .font-14.q-ml-sm.text-primary.text-weight-regular
                                                | В наличии:
                                            .font-14.q-ml-xs.text-positive.text-weight-regular.cursor-pointer(@click="showDrugstoresCard('today')")
                                                | в {{ product.qDs }} {{ drugstoresTodayText }}
                                            .font-14.text-primary.text-weight-regular.full-width.q-pl-md.q-pt-sm
                                                .q-pl-md.line-height-20
                                                    | Оплата онлайн или наличными/картой при получении
                                            q-menu.full-height.full-width(
                                                v-if="drugstoresCard"
                                                anchor="top middle"
                                                self="center left"
                                                transition-show="scale"
                                                transition-hide="scale"
                                                max-width="700px"
                                                max-height="436px"
                                                style="border-radius:26px"
                                            )
                                                q-card.drugstores-card.bg-secondary.q-py-md.q-pl-md(v-if="drugstoresCard")
                                                    q-icon.absolute-top-right.q-pa-md.cursor-pointer(
                                                        @click="drugstoresCard = false"
                                                        name="etabl:cross"
                                                        size="sm"
                                                        color="grey-4")
                                                    .row.q-pl-lg.q-mb-lg
                                                        .font-13.line-height-22.text-weight-medium.cursor-pointer(
                                                            v-if="product.qDs"
                                                            @click="currentDrugstoreFilter = 'today'"
                                                            :class="currentDrugstoreFilter == 'today' ? 'border-positive-strong' : ''")
                                                            | В наличии ({{ product.qDs }})
                                                        //- div(@click="currentDrugstoreFilter = 'fromDate'" v-if="product.preorder")
                                                        //-     .font-13.line-height-22.text-weight-medium.q-ml-xl.cursor-pointer(
                                                        //-         v-if="isOrthopedics"
                                                        //-         :class="currentDrugstoreFilter == 'fromDate' ? 'border-positive-strong' : ''")
                                                        //-         | Под заказ ({{ product.qDs }})
                                                        //-     .font-13.line-height-22.text-weight-medium.q-ml-xl.cursor-pointer(
                                                        //-         v-else
                                                        //-         :class="currentDrugstoreFilter == 'fromDate' ? 'border-positive-strong' : ''")
                                                        //-         | Под заказ ({{ drugstores.length }})
                                                        .font-13.line-height-22.text-weight-medium.q-ml-xl.cursor-pointer(
                                                            @click="currentDrugstoreFilter = 'fromDate'"
                                                            v-if="product.preorder && !product.pku"
                                                            :class="currentDrugstoreFilter == 'fromDate' ? 'border-positive-strong' : ''")
                                                            | Под заказ ({{ drugstores.length }})
                                                        .font-13.line-height-22.text-weight-medium.q-ml-xl.cursor-pointer(
                                                            v-if="allNightDrugstores.length"
                                                            @click="currentDrugstoreFilter = 'allNight'"
                                                            :class="currentDrugstoreFilter == 'allNight' ? 'border-positive-strong' : ''")
                                                            | Круглосуточно ({{ allNightDrugstores.length }})
                                                    q-scroll-area(
                                                        style="height: 350px; border-radius: 0;"
                                                    )
                                                        template(v-for="(item, index) in filteredDrugstores")
                                                            .row
                                                                .col-1.flex.items-center
                                                                    q-icon.q-ml-lg(
                                                                        v-if="item.isDayAndNight"
                                                                        name="etabl:all-night"
                                                                        color="positive"
                                                                        size="24px"
                                                                    )
                                                                .col-8.column.cursor-pointer(@click="scrollToDrugstores")
                                                                    .row.items-center
                                                                        .font-16.line-height-22
                                                                            | {{ item.geo.city_name }} {{ item.geo.address}}
                                                                        q-icon.q-ml-lg(
                                                                            name="etabl:location-marker"
                                                                            color="positive"
                                                                            size="20px"
                                                                        )
                                                                    .row
                                                                        template(v-if="item.isDayAndNight")
                                                                            .font-13.text-grey-9.line-height-20
                                                                                | График работы:
                                                                            .font-13.text-positive.line-height-20.q-ml-xs.text-weight-medium
                                                                                | Круглосуточно
                                                                        template(v-else)
                                                                            .font-13.text-grey-9.line-height-20
                                                                                | {{ item.scheduleRepresentation }}
                                                                .col-3.flex.items-center.justify-center
                                                                    .font-16.line-height-20.text-weight-bold
                                                                        template(v-if="currentDrugstoreFilter == 'allNight' && !item.drugstore_balance && item.preorder_available")
                                                                            | {{ product.price }}&nbsp;₽
                                                                        template(v-if="currentDrugstoreFilter == 'today' || ( currentDrugstoreFilter == 'allNight' && item.drugstore_balance )")
                                                                            | {{ item.drugstore_price }}&nbsp;₽
                                                                        template(v-if="currentDrugstoreFilter == 'fromDate'")
                                                                            | {{ product.priceNew }}&nbsp;₽
                                                            q-separator.q-mx-xl(color="green-7")
                                            q-separator.full-width.q-mt-sm(color="green-7")
                                        .row.items-center.q-mt-sm(v-if="product.preorder && !product.pku")
                                            q-icon(
                                                name="etabl:completed"
                                                size="24px"
                                                color="positive")
                                            .font-14.q-ml-sm.text-primary.text-weight-regular
                                                | Под заказ:
                                            .font-14.q-ml-xs.text-positive.text-weight-regular.cursor-pointer(@click="showDrugstoresCard('fromDate')")
                                                template(v-if="isOrthopedics")
                                                    | в {{ orthopedicsDrugstores.length }} {{ orthopedicsDrugstoresPreorderText }}
                                                template(v-if="isOptics")
                                                    | в {{  opticsDrugstores.length }} {{ opticsDrugstoresPreorderText }}
                                                template(v-if="!isOrthopedics && !isOptics")
                                                    | в {{ drugstores.length }} {{ drugstoresPreorderText }}
                                            .font-14.text-primary.text-weight-regular.full-width.q-pl-md.q-pt-sm
                                                .q-pl-md.line-height-20
                                                    | Оплата онлайн картой
                                            q-menu.full-height.full-width(
                                                v-if="drugstoresCard"
                                                anchor="top middle"
                                                self="center left"
                                                transition-show="scale"
                                                transition-hide="scale"
                                                max-width="700px"
                                                max-height="436px"
                                                style="border-radius:26px"
                                            )
                                                q-card.drugstores-card.bg-secondary.q-py-md.q-pl-md(v-if="drugstoresCard")
                                                    q-icon.absolute-top-right.q-pa-md.cursor-pointer(
                                                        @click="drugstoresCard = false"
                                                        name="etabl:cross"
                                                        size="sm"
                                                        color="grey-4")
                                                    .row.q-pl-lg.q-mb-lg
                                                        .font-13.line-height-22.text-weight-medium.cursor-pointer(
                                                            v-if="product.qDs"
                                                            @click="currentDrugstoreFilter = 'today'"
                                                            :class="currentDrugstoreFilter == 'today' ? 'border-positive-strong' : ''")
                                                            | В наличии ({{ product.qDs }})
                                                        //- div(@click="currentDrugstoreFilter = 'fromDate'" v-if="product.preorder")
                                                        //-     .font-13.line-height-22.text-weight-medium.q-ml-xl.cursor-pointer(
                                                        //-         v-if="isOrthopedics"
                                                        //-         :class="currentDrugstoreFilter == 'fromDate' ? 'border-positive-strong' : ''")
                                                        //-         | Под заказ ({{ product.qDs }})
                                                        //-     .font-13.line-height-22.text-weight-medium.q-ml-xl.cursor-pointer(
                                                        //-         v-else
                                                        //-         :class="currentDrugstoreFilter == 'fromDate' ? 'border-positive-strong' : ''")
                                                        //-         | Под заказ ({{ drugstores.length }})
                                                        .font-13.line-height-22.text-weight-medium.q-ml-xl.cursor-pointer(
                                                            @click="currentDrugstoreFilter = 'fromDate'"
                                                            v-if="product.preorder && !product.pku"
                                                            :class="currentDrugstoreFilter == 'fromDate' ? 'border-positive-strong' : ''")
                                                            | Под заказ ({{ drugstores.length }})
                                                        .font-13.line-height-22.text-weight-medium.q-ml-xl.cursor-pointer(
                                                            v-if="allNightDrugstores.length"
                                                            @click="currentDrugstoreFilter = 'allNight'"
                                                            :class="currentDrugstoreFilter == 'allNight' ? 'border-positive-strong' : ''")
                                                            | Круглосуточно ({{ allNightDrugstores.length }})
                                                    q-scroll-area(
                                                        style="height: 350px; border-radius: 0;"
                                                    )
                                                        template(v-for="(item, index) in filteredDrugstores")
                                                            .row
                                                                .col-1.flex.items-center
                                                                    q-icon.q-ml-lg(
                                                                        v-if="item.isDayAndNight"
                                                                        name="etabl:all-night"
                                                                        color="positive"
                                                                        size="24px"
                                                                    )
                                                                .col-8.column.cursor-pointer(@click="scrollToDrugstores")
                                                                    .row.items-center
                                                                        .font-16.line-height-22
                                                                            | {{ item.geo.city_name }} {{ item.geo.address}}
                                                                        q-icon.q-ml-lg(
                                                                            name="etabl:location-marker"
                                                                            color="positive"
                                                                            size="20px"
                                                                        )
                                                                    .row
                                                                        template(v-if="item.isDayAndNight")
                                                                            .font-13.text-grey-9.line-height-20
                                                                                | График работы:
                                                                            .font-13.text-positive.line-height-20.q-ml-xs.text-weight-medium
                                                                                | Круглосуточно
                                                                        template(v-else)
                                                                            .font-13.text-grey-9.line-height-20
                                                                                | {{ item.scheduleRepresentation }}
                                                                .col-3.flex.items-center.justify-center
                                                                    .font-16.line-height-20.text-weight-bold
                                                                        template(v-if="currentDrugstoreFilter == 'allNight' && !item.drugstore_balance && item.preorder_available")
                                                                            | {{ product.price }}&nbsp;₽
                                                                        template(v-if="currentDrugstoreFilter == 'today' || ( currentDrugstoreFilter == 'allNight' && item.drugstore_balance )")
                                                                            | {{ item.drugstore_price }}&nbsp;₽
                                                                        template(v-if="currentDrugstoreFilter == 'fromDate'")
                                                                            | {{ product.priceNew }}&nbsp;₽
                                                            q-separator.q-mx-xl(color="green-7")
                                            q-separator.full-width.q-mt-sm(color="green-7")
                                        .row.items-center.q-mt-sm(v-if="delivery && (product.qDs || product.isPreorder) && !freeDelivery && !product.pku")
                                            q-icon(
                                                name="etabl:car_delivery"
                                                size="24px"
                                                color="positive")
                                            .font-14.q-ml-sm.text-primary.text-weight-regular
                                                | Доставка курьером:
                                            .font-14.q-ml-xs.text-positive.text-weight-regular
                                                | от 200 ₽
                                            .font-14.text-primary.text-weight-regular.full-width.q-pl-md.q-pt-sm
                                                .q-pl-md.line-height-20
                                                    | Оплата онлайн картой
                                            q-separator.full-width.q-mt-sm(color="green-7")
                                        .row.items-center.q-mt-sm(v-if="(product.qDs || product.isPreorder) && freeDeliveryOne && !product.pku")
                                            q-icon(
                                                name="etabl:car_delivery"
                                                size="24px"
                                                color="positive")
                                            .font-14.q-ml-sm.text-primary.text-weight-regular
                                                | Доставка курьером:
                                            .font-14.q-ml-xs.text-positive.text-weight-regular
                                                | Бесплатно
                                            .font-14.text-primary.text-weight-regular.full-width.q-pl-md.q-pt-sm
                                                .q-pl-md.line-height-20
                                                    | Оплата онлайн картой
                                            q-separator.full-width.q-mt-sm(color="green-7")
                                        .row.items-center.q-mt-sm(v-if="(product.qDs || product.isPreorder) && freeDeliveryTwo && !product.pku")
                                            q-icon(
                                                :name="product.delivery == 1 ? 'etabl:delivery_one' : 'etabl:delivery_two'"
                                                size="24px"
                                                :color="product.delivery == 1 ? 'positive' : 'deep-purple-6'")
                                            .font-14.q-ml-sm.text-primary.text-weight-regular
                                                | Доставка курьером:
                                            .font-14.q-ml-xs.text-positive.text-weight-regular
                                                | Бесплатно от 2 шт.
                                            .font-14.text-primary.text-weight-regular.full-width.q-pl-md.q-pt-sm
                                                .q-pl-md.line-height-20
                                                    | Оплата онлайн картой
                                            q-separator.full-width.q-mt-sm(color="green-7")
                                        .row.items-center.q-mt-sm(v-if="allNightDrugstores.length")
                                            q-icon(
                                                name="etabl:all-night"
                                                size="24px"
                                                color="positive")
                                            .font-14.q-ml-sm.text-primary.text-weight-regular
                                                | Круглосуточно:
                                            .font-14.q-ml-xs.text-positive.text-weight-regular.cursor-pointer(@click="showDrugstoresCard('allNight')")
                                                | в {{ allNightDrugstores.length }} {{ drugstoresAllNightText }}
                                            q-menu.full-height.full-width(
                                                v-if="drugstoresCard"
                                                anchor="top middle"
                                                self="center left"
                                                transition-show="scale"
                                                transition-hide="scale"
                                                max-width="700px"
                                                max-height="436px"
                                                style="border-radius:26px"
                                            )
                                                q-card.drugstores-card.bg-secondary.q-py-md.q-pl-md(v-if="drugstoresCard")
                                                    q-icon.absolute-top-right.q-pa-md.cursor-pointer(
                                                        @click="drugstoresCard = false"
                                                        name="etabl:cross"
                                                        size="sm"
                                                        color="grey-4")
                                                    .row.q-pl-lg.q-mb-lg
                                                        .font-13.line-height-22.text-weight-medium.cursor-pointer(
                                                            v-if="product.qDs"
                                                            @click="currentDrugstoreFilter = 'today'"
                                                            :class="currentDrugstoreFilter == 'today' ? 'border-positive-strong' : ''")
                                                            | В наличии ({{ product.qDs }})
                                                        //- div(@click="currentDrugstoreFilter = 'fromDate'" v-if="product.preorder")
                                                        //-     .font-13.line-height-22.text-weight-medium.q-ml-xl.cursor-pointer(
                                                        //-         v-if="isOrthopedics"
                                                        //-         :class="currentDrugstoreFilter == 'fromDate' ? 'border-positive-strong' : ''")
                                                        //-         | Под заказ ({{ product.qDs }})
                                                        //-     .font-13.line-height-22.text-weight-medium.q-ml-xl.cursor-pointer(
                                                        //-         v-else
                                                        //-         :class="currentDrugstoreFilter == 'fromDate' ? 'border-positive-strong' : ''")
                                                        //-         | Под заказ ({{ drugstores.length }})
                                                        .font-13.line-height-22.text-weight-medium.q-ml-xl.cursor-pointer(
                                                            @click="currentDrugstoreFilter = 'fromDate'"
                                                            v-if="product.preorder && !product.pku"
                                                            :class="currentDrugstoreFilter == 'fromDate' ? 'border-positive-strong' : ''")
                                                            | Под заказ ({{ drugstores.length }})
                                                        .font-13.line-height-22.text-weight-medium.q-ml-xl.cursor-pointer(
                                                            v-if="allNightDrugstores.length"
                                                            @click="currentDrugstoreFilter = 'allNight'"
                                                            :class="currentDrugstoreFilter == 'allNight' ? 'border-positive-strong' : ''")
                                                            | Круглосуточно ({{ allNightDrugstores.length }})
                                                    q-scroll-area(
                                                        style="height: 350px; border-radius: 0;"
                                                    )
                                                        template(v-for="(item, index) in filteredDrugstores")
                                                            .row
                                                                .col-1.flex.items-center
                                                                    q-icon.q-ml-lg(
                                                                        v-if="item.isDayAndNight"
                                                                        name="etabl:all-night"
                                                                        color="positive"
                                                                        size="24px"
                                                                    )
                                                                .col-8.column.cursor-pointer(@click="scrollToDrugstores")
                                                                    .row.items-center
                                                                        .font-16.line-height-22
                                                                            | {{ item.geo.city_name }} {{ item.geo.address}}
                                                                        q-icon.q-ml-lg(
                                                                            name="etabl:location-marker"
                                                                            color="positive"
                                                                            size="20px"
                                                                        )
                                                                    .row
                                                                        template(v-if="item.isDayAndNight")
                                                                            .font-13.text-grey-9.line-height-20
                                                                                | График работы:
                                                                            .font-13.text-positive.line-height-20.q-ml-xs.text-weight-medium
                                                                                | Круглосуточно
                                                                        template(v-else)
                                                                            .font-13.text-grey-9.line-height-20
                                                                                | {{ item.scheduleRepresentation }}
                                                                .col-3.flex.items-center.justify-center
                                                                    .font-16.line-height-20.text-weight-bold
                                                                        template(v-if="currentDrugstoreFilter == 'allNight' && !item.drugstore_balance && item.preorder_available")
                                                                            | {{ product.price }}&nbsp;₽
                                                                        template(v-if="currentDrugstoreFilter == 'today' || ( currentDrugstoreFilter == 'allNight' && item.drugstore_balance )")
                                                                            | {{ item.drugstore_price }}&nbsp;₽
                                                                        template(v-if="currentDrugstoreFilter == 'fromDate'")
                                                                            | {{ product.priceNew }}&nbsp;₽
                                                            q-separator.q-mx-xl(color="green-7")
                                            q-separator.full-width.q-mt-sm(color="green-7")
                                        .row.items-center.q-mt-sm
                                            q-icon(
                                                name="etabl:wide-payment"
                                                size="24px"
                                                color="positive")
                                            .font-14.q-ml-sm.text-primary.text-weight-regular(v-if="product.qDs && !product.pku")
                                                | Онлайн оплата/при получении
                                            .font-14.q-ml-sm.text-primary.text-weight-regular(v-if="!product.qDs && !product.pku")
                                                | Онлайн оплата
                                            .font-14.q-ml-sm.text-primary.text-weight-regular(v-if="product.pku")
                                                | Оплата при получении
                                            q-separator.full-width.q-mt-sm(color="green-7")
                        .col-5.q-ml-md(:style="isActivAccessibility ? {} : { 'max-width': '287px' }")

                            .b-radius-16.bg-white-b.q-pa-md.row.items-center
                                .row.items-end.full-width.justify-between
                                    template(v-if="!notAvailable")
                                        .font-24.line-height-22.text-weight-bold.text-primary.q-mr-lg.line-height-32
                                            | Цена
                                        .row.text-positive.line-height-22.items-end.column(v-if="salePercent > 0" )
                                            .row.no-wrap.items-center
                                                .sale.b-radius-16.outline-negative.flex.items-center.q-mr-sm(style="padding: 2px 4px")
                                                    .font-12.line-height-16.text-negative.text-weight-medium
                                                        | {{ salePercent }}%
                                                .text-weight-medium.q-mr-xs(v-if="!product.isMarker && priceCrossed" )
                                                    | от
                                                span.text-grey-9.font-13.text-weight-medium(
                                                    style="text-decoration: line-through;")
                                                    span(v-if="!userAddress?.address_id" ) от&nbsp;
                                                    | {{ new Intl.NumberFormat('ru-RU').format(product.priceCrossed).replace(',','.') }}
                                                    span &nbsp;₽

                                            div
                                                span.text-weight-bold.font-24.text-positive.q-ml-xs.line-height-32.font-24
                                                    span(v-if="!userAddress?.address_id" ) от&nbsp;
                                                    | {{ new Intl.NumberFormat('ru-RU').format(product.price).replace(',','.') }}
                                                    span &nbsp;₽
                                        .row.text-positive.line-height-22.items-baseline.font-24(v-else)
                                            .text-weight-medium.q-mr-xs(v-if="!product.isMarker" )
                                                | от
                                            .font-24.text-weight-bold
                                                |  {{ new Intl.NumberFormat('ru-RU').format(product.price).replace(',','.') }}
                                                span &nbsp;₽
                                div.q-mt-lg.full-width
                                    q-no-ssr
                                        template(v-if="notAvailable")
                                            base-btn(
                                                color="accent"
                                                text_color="primary"
                                                label="Нет в наличии"
                                                height="40"
                                                :width="windowWidth >= 1280 ? 255 : 190"
                                                font_size="16"
                                                bradius="20"
                                                :loading="loading"
                                                :disable="loading"
                                                loading_color="secondary").product__add-to-cart
                                        template(v-else)
                                            base-btn(
                                                color="accent"
                                                text_color="positive"
                                                label="Только в аптеке"
                                                height="40"
                                                :width="windowWidth >= 1280 ? 255 : 190"
                                                font_size="16"
                                                bradius="20"
                                                :loading="loading"
                                                :disable="loading"
                                                loading_color="secondary"
                                                v-if="product.limit === 0 || product.pku").product__add-to-cart
                                            template(v-else)
                                                button.row.items-center.justify-between.product__amount.product__add-to-cart.cursor-pointer(
                                                    v-if="inCart"
                                                    :style="windowWidth >= 1280 ? 'width: 255px' : 'width: 190px'"
                                                    @click.stop="goToCart"
                                                )
                                                    span Оформить
                                                    .row.justify-end.product__counter
                                                        q-btn.justify-center.items-center.product__button.product__button-min.cursor-pointer.font-18.text-positive(
                                                            unelevated
                                                            rounded
                                                            @click.stop="setAmount(0)") &ndash;
                                                        .row.justify-center.items-center.product__count.font-18.text-weight-medium.text-positive {{ amount }}
                                                        q-btn.justify-center.items-center.product__button.product__button-plus.cursor-pointer.font-18.text-positive(
                                                            v-if="!preventAmoutUp"
                                                            unelevated
                                                            rounded
                                                            @click.stop="setAmount(1)") +
                                                        q-btn.justify-center.items-center.product__button.product__button__disable.cursor-pointer.font-18(
                                                            v-else
                                                            unelevated
                                                            rounded
                                                            @click.stop="") +
                                                            base-tooltip(
                                                                style="max-width: 300px;"
                                                                title="Количество ограничено")
                                                base-btn(
                                                    v-else
                                                    label="В корзину"
                                                    height="40"
                                                    :width="windowWidth >= 1280 ? 255 : 190"
                                                    @click="addToCart"
                                                    font_size="16"
                                                    bradius="20"
                                                    :loading="loading"
                                                    :disable="loading"
                                                    loading_color="secondary"
                                                ).product__add-to-cart

                                            base-btn.q-mt-md(
                                                v-if="!product.pku"
                                                color="secondary"
                                                text_color="blue-12"
                                                label="Покупка в 1 клик"
                                                height="40"
                                                :width="windowWidth >= 1280 ? 255 : 190"
                                                font_size="16"
                                                bradius="20"
                                                @click="fastBuy"
                                                :loading="loading"
                                                :disable="loading"
                                                loading_color="secondary"
                                                border="1px solid #2D8BB2"
                                            ).product__add-to-cart
                                    template(v-if="notAvailable")
                                        .row.items-center.no-wrap.q-mt-lg.justify-center
                                            .text-weight-medium.text-primary.flex.items-center
                                                | Подписаться на товар
                                            q-toggle(
                                                v-model="subscribe"
                                                color="positive"
                                            )
                                            //base-btn(
                                            //    v-if="!product.pku"
                                            //    color="secondary"
                                            //    text_color="blue-12"
                                            //    label="Покупка в 1 клик"
                                            //    height="40"
                                            //    :width="windowWidth >= 1280 ? 255 : 190"
                                            //    font_size="16"
                                            //    bradius="20"
                                            //    @click="fastBuy"
                                            //    :loading="loading"
                                            //    :disable="loading"
                                            //    loading_color="secondary"
                                            //    border="1px solid #2D8BB2"
                                            //    style="margin-left: 24px !important;"
                                            //).product__add-to-cart.q-ml-lg
                                div.full-width
                                    .row.items-center.q-mt-sm(v-if="delivery && (product.qDs || product.isPreorder) && !freeDelivery && !product.pku")
                                        .row.no-wrap.items-center
                                            q-icon(
                                                name="etabl:car_delivery"
                                                size="26px"
                                                color="positive")
                                            .font-14.q-ml-sm.text-primary
                                                | Доставка курьером:
                                        .font-14.q-ml-xs.text-positive.text-weight-regular
                                            | от 200 ₽
                                    .row.items-center.q-mt-sm(v-if="(product.qDs || product.isPreorder) && freeDeliveryOne && !product.pku")
                                        .row.no-wrap.items-center
                                            q-icon(
                                                name="etabl:car_delivery"
                                                size="26px"
                                                color="positive")
                                            .font-14.q-ml-sm.text-primary
                                                | Доставка курьером:
                                        .font-14.q-ml-xs.text-positive.text-weight-regular
                                            | Бесплатно
                                    .row.items-center.q-mt-sm(v-if="(product.qDs || product.isPreorder) && freeDeliveryTwo && !product.pku")
                                        .row.no-wrap.items-center
                                            q-icon(
                                                :name="product.delivery == 1 ? 'etabl:delivery_one' : 'etabl:delivery_two'"
                                                size="26px"
                                                :color="product.delivery == 1 ? 'positive' : 'deep-purple-6'"
                                            )
                                            .font-14.q-ml-sm.text-primary
                                                | Доставка:
                                        .font-14.q-ml-xs.text-positive.text-weight-regular
                                            | Бесплатно от 2 шт.
                                    .row.items-center.q-mt-sm(v-if="product?.isPrescription && product?.isErp")
                                        .row.no-wrap.items-center
                                            q-icon(
                                                name="img:rx_e.svg"
                                                size="26px"
                                                color="negative")
                                            .font-14.q-ml-sm.text-primary
                                                | Доставка по электронному рецепту


                            .row.q-pa-md.q-mt-lg(v-if="(product?.advertisment_info?.length || product?.productActivities?.length) && !notAvailable && product.qDs >= 1 " )
                                .text-primary.font-24.text-weight-bold.row(style="gap: 8px" ) Участвует в акциях:
                                    .q-px-sm.q-py-xs.text-white.font-12.text-weight-regular.b-radius-16.cursor-pointer(
                                        :class="promotionNameplate"
                                        v-for="(sale,idx) of product?.productActivities?.length ? product?.productActivities : product.advertisment_info"
                                        style="max-width: fit-content"
                                    )
                                        router-link.text-white(
                                            :to="city ? `/${city?.slug}/marketing/${sale.advertisment_id}` : `/marketing/${sale.advertisment_id}`"
                                            target="_blank"
                                        )
                                            div {{sale.title}}
                                div.full-width.q-mt-sm
                                    .text-grey-9.font-12.text-weight-regular(
                                        style="max-width: fit-content"
                                    ) *Скидки и акции не суммируются



            //q-card.drugstores-card.bg-secondary.q-py-md.q-pl-md(v-if="drugstoresCard")
            //    q-icon.absolute-top-right.q-pa-md.cursor-pointer(
            //        @click="drugstoresCard = false"
            //        name="etabl:cross"
            //        size="sm"
            //        color="grey-4")
            //    .row.q-pl-lg.q-mb-lg
            //        .font-13.line-height-22.text-weight-medium.cursor-pointer(
            //            v-if="product.qDs"
            //            @click="currentDrugstoreFilter = 'today'"
            //            :class="currentDrugstoreFilter == 'today' ? 'border-positive-strong' : ''")
            //            | В наличии ({{ product.qDs }})
            //        //- div(@click="currentDrugstoreFilter = 'fromDate'" v-if="product.preorder")
            //        //-     .font-13.line-height-22.text-weight-medium.q-ml-xl.cursor-pointer(
            //        //-         v-if="isOrthopedics"
            //        //-         :class="currentDrugstoreFilter == 'fromDate' ? 'border-positive-strong' : ''")
            //        //-         | Под заказ ({{ product.qDs }})
            //        //-     .font-13.line-height-22.text-weight-medium.q-ml-xl.cursor-pointer(
            //        //-         v-else
            //        //-         :class="currentDrugstoreFilter == 'fromDate' ? 'border-positive-strong' : ''")
            //        //-         | Под заказ ({{ drugstores.length }})
            //        .font-13.line-height-22.text-weight-medium.q-ml-xl.cursor-pointer(
            //            @click="currentDrugstoreFilter = 'fromDate'"
            //            v-if="product.preorder && !product.pku"
            //            :class="currentDrugstoreFilter == 'fromDate' ? 'border-positive-strong' : ''")
            //            | Под заказ ({{ drugstores.length }})
            //        .font-13.line-height-22.text-weight-medium.q-ml-xl.cursor-pointer(
            //            v-if="allNightDrugstores.length"
            //            @click="currentDrugstoreFilter = 'allNight'"
            //            :class="currentDrugstoreFilter == 'allNight' ? 'border-positive-strong' : ''")
            //            | Круглосуточно ({{ allNightDrugstores.length }})
            //    q-scroll-area(
            //        style="height: 350px; border-radius: 0;"
            //    )
            //        template(v-for="(item, index) in filteredDrugstores")
            //            .row
            //                .col-1.flex.items-center
            //                    q-icon.q-ml-lg(
            //                        v-if="item.isDayAndNight"
            //                        name="etabl:all-night"
            //                        color="positive"
            //                        size="24px"
            //                    )
            //                .col-8.column.cursor-pointer(@click="scrollToDrugstores")
            //                    .row.items-center
            //                        .font-16.line-height-22
            //                            | {{ item.geo.city_name }} {{ item.geo.address}}
            //                        q-icon.q-ml-lg(
            //                            name="etabl:location-marker"
            //                            color="positive"
            //                            size="20px"
            //                        )
            //                    .row
            //                        template(v-if="item.isDayAndNight")
            //                            .font-13.text-grey-9.line-height-20
            //                                | График работы:
            //                            .font-13.text-positive.line-height-20.q-ml-xs.text-weight-medium
            //                                | Круглосуточно
            //                        template(v-else)
            //                            .font-13.text-grey-9.line-height-20
            //                                | {{ item.scheduleRepresentation }}
            //                .col-3.flex.items-center.justify-center
            //                    .font-16.line-height-20.text-weight-bold
            //                        template(v-if="currentDrugstoreFilter == 'allNight' && !item.drugstore_balance && item.preorder_available")
            //                            | {{ product.price }}&nbsp;₽
            //                        template(v-if="currentDrugstoreFilter == 'today' || ( currentDrugstoreFilter == 'allNight' && item.drugstore_balance )")
            //                            | {{ item.drugstore_price }}&nbsp;₽
            //                        template(v-if="currentDrugstoreFilter == 'fromDate'")
            //                            | {{ product.priceNew }}&nbsp;₽
            //            q-separator.q-mx-xl(color="green-7")
        .col-12.additional.q-pr-lg.q-py-md.q-my-lg#additional(v-if="additionalSales?.length")
            product-slider-skeleton-desktop(
                title
                :height="350"
                v-if="!additionalSales")
            template(v-if="additionalSales && additionalSales?.length")
                .text-primary.font-32.text-weight-bold.q-pl-lg.q-pb-lg.line-height-42
                    | С этим товаром также покупают
                product-slider-desktop(:slides="additionalSales" :standartPreview="false" prodPage)
        .col-12.analogs#analogs(v-if="productAnalogs?.length")
            product-slider-skeleton-desktop(
                title
                :height="350"
                v-if="!productAnalogs")
            template(v-else-if="productAnalogs && productAnalogs.length")
                h2.text-primary.font-32.text-weight-bold.q-pb-lg.line-height-42
                    | Аналоги {{ product.name }}
                product-slider-desktop(:slides="productAnalogs")
        .instruction.q-pt-md#instruction(v-if="description")
            h2.instruction__title.q-pa-none.line-height-42 Инструкция по применению {{ product.name }}
            .q-my-lg
                a.instruction__item(
                    @click="abs('manufacturer', true)"
                    :class="[{'text-positive text-weight-bold bottom-line' : activeInstruction === 'manufacturer'}]"
                )

                    | Производитель
                template(v-for="item in description" :key="item.order")
                    a.instruction__item(
                        v-if="item.value"
                        @click="abs(item.title, true)"
                        :class="[{'text-positive text-weight-bold bottom-line' : activeInstruction === item.title}]"
                    )
                        | {{ item.title }}
            .q-mb-sm.font-16.cursor-pointer(@click="isOpenDescription = !isOpenDescription" v-if="!isOpenDescription" )
                span.instruction__item.text-positive Показать всё
                q-icon(
                    :name="isOpenDescription ? `etabl:arrow_up` : `etabl:arrow_down`"
                    size="14px"
                    color="positive"
                )

            q-slide-transition(:duration="400")
                div(v-show="isOpenDescription")
                    h2.font-24.text-weight-bold.text-primary.q-pa-none.q-py-sm(id="manufacturer")
                        | Производитель
                    .font-18.text-primary.text-weight-regular.q-py-sm.line-height-22 {{product.manufacture}}

                    template(v-for="item in description" :key="item.order")
                        .row.full-width
                            .col-12
                                base-textblock.justify-text(:id="item.title" :title="item.title" :info="item.value")
                    .font-18.text-primary.text-weight-regular.line-height-22.q-pt-sm.q-pb-md
                        | Производитель оставляет за собой право менять инструкцию и/или характеристики товара,
                        | внешний вид упаковки и комплектацию без предварительного уведомления торговой площадки.
            .q-mb-sm.font-16.cursor-pointer(@click="isOpenDescription = !isOpenDescription" v-if="isOpenDescription" )
                span.instruction__item.text-positive Скрыть всё
                q-icon(
                    :name="isOpenDescription ? `etabl:arrow_up` : `etabl:arrow_down`"
                    size="14px"
                    color="positive"
                )

        .font-16.text-weight-regular(v-if="product.seoContent" v-html="product.seoContent")
        .col-12.analogs.q-pt-md#formfactor(v-if="formFactor?.length")
            product-slider-skeleton-desktop(
                title
                :height="350"
                v-if="!formFactor")
            template(v-if="formFactor && formFactor.length")
                h2.text-primary.font-32.text-weight-bold.q-pb-lg.line-height-42(v-if="product.groupCategory.code == '000000001'")
                    | Лекарственная форма {{ product.name }}
                h2.text-primary.font-20.text-weight-medium.q-pb-lg.line-height-42(v-else)
                    | Форма выпуска
                product-slider-desktop(:slides="formFactor")
        .col-12.q-mb-md.q-mt-md.q-pt-md#reviews
            .reviews.column.q-px-lg.q-py-md
                .row.justify-between.items-center(
                    :class="product.reviews?.length ? 'q-mb-sm' : 'q-mb-md'"
                )
                    .col-9
                        h2.text-primary.font-32.text-weight-bold.q-pa-none.line-height-42(v-if="product.reviews?.length" )
                            | Отзывы о {{ product.name }} {{ product.subtitleShort }}
                        h2.text-primary.font-32.text-weight-bold.q-pa-none.line-height-42(v-else )
                            | Отзывы
                    .row.col-3.justify-end
                        base-btn(
                            label="Написать отзыв"
                            height="40"
                            width="200"
                            bradius="20"
                            font_size="16"
                            @click="showReviewForm")
                .row(v-if="product.reviews?.length")
                    q-icon.q-mr-sm(
                        v-for="n in productRatingRound"
                        name="etabl:star-fill"
                        size="20px"
                        color="positive"
                    )
                    q-icon.q-mr-sm(
                        v-for="n in 5 - productRatingRound"
                        name="etabl:star"
                        size="20px"
                        color="positive"
                    )
                    .q-ml-sm.text-primary
                        | Рейтинг {{ productRating }} на основе {{ product.reviews?.length }} отзывов
                q-separator.q-my-md(color="green-7" v-if="product.reviews?.length")
                span(v-if="!product.reviews?.length")
                    | Пока нет отзывов о данном товаре
                .column(
                    v-for="(item, index) in product.reviews"
                    :key="index"
                    :class="[{'q-mb-lg' : showAllReviews || index <= 2}]"
                )
                    template(v-if="showAllReviews || index <= 2")
                        .row
                            q-icon.q-mr-sm(
                                v-for="n in item.rating"
                                name="etabl:star-fill"
                                size="20px"
                                color="positive"
                            )
                            q-icon.q-mr-sm(
                                v-for="n in 5 - item.rating"
                                name="etabl:star"
                                size="20px"
                                color="positive"
                            )
                        .q-mt-md
                            | {{ item.review }}
                        .q-mt-md.text-weight-medium.text-grey-9
                            | {{ item.name }} | {{ new Date( item.created).toLocaleDateString('ru-Ru', {day: '2-digit', month: 'long', year: 'numeric'}) }}
                        q-separator.q-mt-md(color="green-7" v-if="index != product.reviews?.length - 1")
                .justify-center.flex(v-if="product.reviews?.length > 3")
                    base-btn(
                        :label="showAllReviews ? 'Скрыть отзывы' : 'Смотреть все отзывы'"
                        height="40"
                        width="200"
                        bradius="20"
                        @click="showAllReviews = !showAllReviews")
        .col-12.q-pt-md(v-if="drugstores && !notAvailable").q-pb-md#drugstores
            h2.text-primary.font-32.text-weight-bold.line-height-42
                | Наличие в аптеках {{ product.name }}
            drugstore-list-desktop(
                v-if="drugstoreList"
                v-for="(item, index) in drugstores"
                :drugstore="item")
                template(v-slot:bages)
                    .font-16.text-weight-medium.text-positive
                        | {{ item.drugstore_price }}
                        template(v-if="item.drugstore_price")
                            | р.
            base-map(
                :drugstoreOnly="product.limit === 0 || product.pku"
                :drugstores="drugstores"
                :productPage="true"
                :basket="false"
                :qDs="!!product.qDs"
                :isOrthopedics="isOrthopedics"
                :isOptics="isOptics"
                style="height: 600px")
                // .col-12.q-pb-xl
        .q-pb-xl.q-pt-md(v-if="history && history?.length && userAuthorized")
            h2.text-primary.font-32.text-weight-bold.q-pb-lg.line-height-42
                | Вы недавно просматривали
            product-slider-desktop(:slides="history")
        q-dialog(v-model="openImg")
            q-card.modal-preview
                img(
                    :src="product.previewImage"
                    :title="`${product.name} ${ product.subtitleShort } (${ product.manufacture }, ${ product.country })`"
                    :alt="`${product.name} ${ product.subtitleShort } (${ product.manufacture }, ${ product.country })`")
                q-btn.absolute-top-right.modal-preview__close-img(
                    flat
                    round
                    fab-mini
                    @click="openImg = false")
                    q-icon(
                        name="etabl:cross"
                        size="xs"
                        color="grey-4")
.anchor-block(v-if="showAnchor")
    .row.top-anchors.items-center.bg-secondary
        .col-1
            q-img(
                :no-spinner="isActivAccessibility"
                :src="product.previewImage"
                height="45px"
                fit="contain"
                :title="`${product.name} ${ product.subtitleShort } (${ product.manufacture }, ${ product.country })`"
                :alt="`${product.name} ${ product.subtitleShort } (${ product.manufacture }, ${ product.country })`"
            )
        .col-4
            .row.font-20.line-height-22.text-weight-bold.text-primary.q-pl-lg
                span.row.items-center#name
                    | {{  product.name }} {{  product.subtitleShort }}
        .col-4.row.items-center.justify-end.no-wrap.q-pr-lg
            template(v-if="!notAvailable")
                .font-24.line-height-22.text-weight-bold.text-primary.q-mr-sm
                    | Цена
                .sale.b-radius-16.border-negative.flex.items-center.q-mr-sm.q-ml-xs(
                    style="padding: 2px 4px"
                    v-if="salePercent > 0"
                )
                    .font-12.line-height-16.text-negative.text-weight-medium
                        | {{ salePercent }}%
                .row.text-positive.line-height-24.font-20.items-center.no-wrap(v-if="salePercent > 0" )
                    .text-weight-medium.q-mr-xs(v-if="!product.isMarker && priceCrossed" )
                        | от
                    span.q-mr-sm.text-grey-9.font-13.text-weight-regular(
                        style="text-decoration: line-through;")
                        span(v-if="!userAddress?.address_id" ) от&nbsp;
                        | {{ new Intl.NumberFormat('ru-RU').format(product.priceCrossed).replace(',','.') }}
                        span &nbsp;₽

                    span.text-weight-bold.font-20.text-positive.q-ml-xs
                        span(v-if="!userAddress?.address_id" ) от&nbsp;
                        | {{ new Intl.NumberFormat('ru-RU').format(product.price).replace(',','.') }}
                        span &nbsp;₽
                .row.text-positive.line-height-20.items-baseline.q-ml-xs(v-else)
                    .text-weight-medium.q-mr-xs.font-20.text-weight-bold(v-if="!product.isMarker" )
                        | от
                    .font-20.text-weight-bold
                        |  {{ new Intl.NumberFormat('ru-RU').format(product.price).replace(',','.') }}
                        span &nbsp;₽


        .col-2
            q-no-ssr
                template(v-if="notAvailable")
                    base-btn(
                        color="accent"
                        text_color="positive"
                        label="Нет в наличии"
                        height="40"
                        :width="windowWidth >= 1280 ? 255 : 190"
                        font_size="16"
                        bradius="20"
                        :loading="loading"
                        :disable="loading"
                        loading_color="secondary").product__add-to-cart
                template(v-else)
                    base-btn(
                        color="accent"
                        text_color="positive"
                        label="Только в аптеке"
                        height="40"
                        :width="windowWidth >= 1280 ? 255 : 190"
                        font_size="16"
                        bradius="20"
                        :loading="loading"
                        :disable="loading"
                        loading_color="secondary"
                        v-if="product.limit === 0 || product.pku").product__add-to-cart
                    template(v-else)
                        base-btn(
                            label="В корзину"
                            height="40"
                            :width="windowWidth >= 1280 ? 255 : 190"
                            @click="addToCart"
                            font_size="16"
                            bradius="20"
                            :loading="loading"
                            :disable="loading"
                            loading_color="secondary"
                            v-if="!inCart").product__add-to-cart
                        button.row.items-center.justify-between.product__amount.product__add-to-cart.cursor-pointer(
                            :style="windowWidth >= 1280 ? 'width: 255px' : 'width: 190px'"
                            v-else
                            @click.stop="goToCart")
                            span Оформить
                            .row.justify-end.product__counter
                                q-btn.justify-center.items-center.product__button.product__button-min.cursor-pointer.font-18.text-positive(
                                    unelevated
                                    rounded
                                    @click.stop="setAmount(0)") &ndash;
                                .row.justify-center.items-center.product__count.font-18.text-weight-medium.text-positive {{ amount }}
                                q-btn.justify-center.items-center.product__button.product__button-plus.cursor-pointer.font-18.text-positive(
                                    v-if="!preventAmoutUp"
                                    unelevated
                                    rounded
                                    @click.stop="setAmount(1)") +
                                q-btn.justify-center.items-center.product__button.product__button__disable.cursor-pointer.font-18(
                                    v-else
                                    unelevated
                                    rounded
                                    @click.stop="") +
                                    base-tooltip(
                                        style="max-width: 300px;"
                                        title="Количество ограничено")
    .row.items-center.justify-between.top-anchors
        template(v-for="item in anchorLinks")
            .row.cursor-pointer(v-if="item.condition" @click="scrollTo(item.value)" )
                q-icon.q-mr-sm(
                    :name="`etabl:prod-${item.value}`"
                    size="24px"
                    color="grey-9"
                )
                .font-16.text-primary(
                    :class="`${item.value}Anchor` == (additionalAnchor || overallAnchor || analogsAnchor || instructionAnchor || formfactorAnchor || reviewsAnchor || drugstoresAnchor) ? 'text-positive text-weight-bold bottom-line' : ''")
                    | {{ item.label }}
review-form-desktop(
    :reviewForm="reviewForm"
    :productId="product.id"
    @closeReviewForm="closeReviewForm"
)
</template>

<script>
import { copyToClipboard, scroll, useQuasar } from 'quasar';
import { computed, onMounted, reactive, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import BaseBtn from 'components/Base/BaseBtn.vue';
import BaseBreadcrumbs from 'components/Base/BaseBreadcrumbs.vue';
import ProductSliderDesktop from 'src/components/ProductSlider/ProductSliderDesktop.vue';
import ProductSliderSkeletonDesktop
    from 'components/ProductSlider/ProductSliderSkeletonDesktop.vue';
import PreviewDesktop from 'components/Preview/PreviewDesktop.vue';
import BaseTextblock from 'components/Base/BaseTextblock.vue';
import BaseMap from 'src/components/Base/BaseDesktopMap.vue';
import BaseTooltip from 'components/Base/BaseTooltip.vue';
import DrugstoreListDesktop from 'src/components/Drugstore/DrugstoreListDesktop.vue';
import ReviewFormDesktop from 'src/components/Review/ReviewFormDesktop.vue';

const {getScrollTarget, setVerticalScrollPosition} = scroll;


export default {
    name: 'ProductDesktop',
    components: {
        BaseBreadcrumbs,
        ProductSliderDesktop,
        PreviewDesktop,
        BaseTextblock,
        BaseMap,
        BaseBtn,
        ProductSliderSkeletonDesktop,
        BaseTooltip,
        DrugstoreListDesktop,
        ReviewFormDesktop,
    },
    setup() {
        const route = useRoute();
        const router = useRouter();
        const store = useStore();
        const $q = useQuasar();

        const currentCharact = ref(0);
        const fixedMenu = ref(false);
        const fixedMenuDisatnce = ref(null);
        const heightHeader = ref(null);
        const navBlock = ref(null);
        const containerOffset = ref(null);
        const inStock = ref(false);
        const openMap = ref(false);
        const amount = ref(1);
        const routeObj = reactive([]);
        const readyCrumbs = ref(false);
        const inventories = ref();
        const openImg = ref(false);
        const loading = ref(false);
        const inventoryList = {};
        const amountTimer = ref();
        const reviewForm = ref(false);
        const showAllReviews = ref(false);
        const name = ref(null);
        const email = ref(null);
        const drugstoreList = ref(true);
        const subscribe = ref(true);
        const showAnchor = ref(false);
        const overallAnchor = ref('');
        const analogsAnchor = ref('');
        const instructionAnchor = ref('');
        const formfactorAnchor = ref('');
        const reviewsAnchor = ref('');
        const drugstoresAnchor = ref('');
        const additionalAnchor = ref('');
        const imgHeight = ref(0);
        const allNightDrugstores = ref([]);
        const filteredDrugstores = ref([]);
        const currentDrugstoreFilter = ref('');
        const drugstoresCard = ref(false);
        const isLocalFavourite = ref(false);
        const isOpenDescription = ref(false);
        const showShares = ref(false);
        const showErpTooltip = ref(false);
        const showPrecriptionTooltip = ref(false);
        const showTermoTooltip = ref(false);

        // город пользователя
        const city = computed(() => store.getters['cityForm/CITY']);

        const abs = (anchor, isInstrusction = false) => {
            if (isInstrusction) isOpenDescription.value = true;
            setTimeout(() => scrollTo(anchor, isInstrusction), 300);
        };

        // данные продукта
        const product = computed(() => {
            for (const key of Object.keys(inventoryList)) {
                delete inventoryList[key];
            }
            ;
            const prod = store.getters['products/PRODUCT'];

            if (prod.inventoryList)
                prod.inventoryList.forEach((drugstore) => {
                    inventoryList[drugstore.id] = drugstore;
                });

            return prod;
        });

        const preorderAvialable = computed(() => !!product.value.isPreorder);

        const isOrthopedics = computed(() => product.value.groupCategory.code == '000000496');

        const isOptics = computed(() => product.value.groupCategory.code == '000000569');

        const drugstoresCount = computed(() => product.value.inventoryList.length);

        const userAddress = computed(() => store.getters['user/USER_ADDRESS']);

        const promotionNameplate = computed(() => {
            if (Array.isArray(product?.value.productActivities) && product.value.productActivities.length > 0 && product.value.productActivities[0].title === 'Товар дня') {
                return 'bg-blue-10';
            }
            if ((product.value.discount800 || 0) > 0 || (product.value.discount300 || 0) > 0 || (product.value.priceCrossed && !notAvailable.value)) {
                return 'bg-negative';
            }
            return '';
        });

        const drugstores = computed(() => {
            let result = product.value.inventoryList.filter((item) => !item.isParcelAutomat);

            let drugstoreList = [];

            let allNightDrugstoresRaw = [];

            result.forEach((item) => {
                let drugstore = Object.assign({}, item);
                drugstore['preorder_available'] = preorderAvialable.value;

                if (inventoryList[item.id]) {
                    drugstore['drugstore_balance'] = inventoryList[item.id].drugstoreBalance;
                    drugstore['drugstore_price'] = inventoryList[item.id].drugstorePrice;
                    drugstoreList.push(drugstore);

                    if (inventoryList[item.id].isDayAndNight && !product.value.pku)
                        allNightDrugstoresRaw.push(drugstore);
                    if (inventoryList[item.id].isDayAndNight && product.value.pku && inventoryList[item.id].drugstoreBalance)
                        allNightDrugstoresRaw.push(drugstore);
                } else {
                    drugstore['drugstore_balance'] = 0;
                    drugstore['drugstore_price'] = 0;
                    drugstoreList.push(drugstore);

                    if (drugstore.isDayAndNight && !product.value.pku)
                        allNightDrugstoresRaw.push(drugstore);
                    if (drugstore.isDayAndNight && !product.value.pku && drugstore.drugstoreBalance)
                        allNightDrugstoresRaw.push(drugstore);
                }
            });

            allNightDrugstoresRaw.forEach((item) => {
                if (item.drugstore_balance || item.preorder_available) {
                    allNightDrugstores.value.push(item);
                }
                ;
            });

            return drugstoreList;
        });

        const windowWidth = computed(() => {
            if (process.env.CLIENT) {
                return window.innerWidth;
            } else return '';
        });

        const isActivAccessibility = computed(() => store.getters['styles/isActiv']);

        const termoText = computed(() => {
            let text = null;
            product.value.description.forEach((item) => {
                if (item.title == 'Условия хранения') {
                    text = item.value;
                }
            });

            if (text) {
                return text;
            } else return 'Препарат следует хранить в сухом, защищенном от света месте при температуре от 2° до 8°С.';
        });

        watch(currentDrugstoreFilter, () => {
            if (currentDrugstoreFilter.value == 'today') {
                filteredDrugstores.value = drugstores.value.filter((item) => item.drugstore_price);
            } else if (currentDrugstoreFilter.value == 'fromDate') {
                filteredDrugstores.value = drugstores.value;
            } else if (currentDrugstoreFilter.value == 'allNight') {
                filteredDrugstores.value = allNightDrugstores.value;
            }
        });

        const showDrugstoresCard = (val) => {
            currentDrugstoreFilter.value = val;
            drugstoresCard.value = true;
        };

        const orthopedicsDrugstores = computed(() => {
            if (product.value.preorder)
                return drugstores.value;

            let drugstoresOrt = [];

            drugstores.value.forEach((item) => {
                if (item.isOrthopedics) {
                    drugstoresOrt.push(item);
                } else if (item.drugstoreBalance) {
                    drugstoresOrt.push(item);
                }
            });


            return drugstoresOrt;

        });

        const opticsDrugstores = computed(() => {
            if (product.value.preorder)
                return drugstores.value;

            let drugstoresOpt = [];

            drugstores.value.forEach((item) => {
                if (item.isOptics) {
                    drugstoresOpt.push(item);
                } else if (item.drugstoreBalance) {
                    drugstoresOpt.push(item);
                }
            });


            return drugstoresOpt;

        });

        // аналоги продукта
        const productAnalogs = computed(() => {
            return product.value.analogProducts;
        });

        // продукты другой формы выпуска
        const formFactor = computed(() => {
            return product.value.brandProducts;
        });

        // история просмотров
        const history = computed(() => store.getters['advertisement/HISTORY']);

        // дозаказ
        const additionalSales = computed(() => {
            return product.value.additionalProducts;
        });

        //скидка
        // const salePercent = computed(() => {
        //     return Math.ceil((1 - (product.value.price / product.value.priceCrossed)) * 100);
        // });

        const salePercent = computed(() => {
            if (product.value.priceCrossed) {
                const percent = ((product.value.priceCrossed - product.value.price) / product.value.priceCrossed) * 100;
                const decimalPart = Math.floor((percent % 1) * 10);

                if (decimalPart > 5) {
                    return `${Math.ceil(percent)}`;
                } else {
                    return `${Math.floor(percent)}`;
                }
            } else {
                return false;
            }
        });

        // категории id:url
        const categoriesIdToUrl = computed(() => store.getters['categories/CATEGORIES_ID_TO_URL']);

        // данные пользователя
        const userFavouriteProducts = computed(() => store.getters['user/USER_FAVOURITE_PRODUCTS']);
        const userStorageFavouriteProducts = computed(() => store.getters['localStorage/FAVOURITES']);
        const userCityId = computed(() => store.getters['user/USER_CITY_ID']);
        const userAuthorized = computed(() => store.getters['user/USER_AUTHORIZED']);

        // локальные данные пользователя
        const cartProducts = computed(() => store.getters['localStorage/BASKET_PRODUCTS']);
        const drugstoreId = computed(() => store.getters['localStorage/DRUGSTORE_ID']);

        const isFavourite = computed(() => {
            if (userAuthorized.value) {
                return isLocalFavourite.value;
            } else {
                const favourites = userStorageFavouriteProducts.value;
                return favourites?.find((item) => item === product.value.id);
            }
        });

        const notAvailable = computed(() => {
            return !product.value.qDs
                && (product.value.preorder?.balance !== undefined && !product.value.preorder?.balance
                    || product.value.preorder?.preorder_balance !== undefined && !product.value.preorder?.preorder_balance || !product.value.preorder);
        });

        const inCart = ref(false);

        const description = computed(() => {
            if (product.value?.description)
                for (let item of product.value?.description) {
                    if (item.value) {
                        return product.value.description;
                    }
                }

            return null;
        });

        // удаление товара из корзины для авторизоаванных
        const delProductInCart = async (id = product.value.id) => {
            const in_basket = false;

            try {
                await store.dispatch('basketNew/DELETE_PRODUCT_FROM_BASKET', {id});

                inCart.value = false;

                try {
                    window.dataLayer.push({
                        'ecommerce': {
                            'currencyCode': 'RUB',
                            'remove': {
                                'products': [
                                    {
                                        'id': product.value.id,
                                        'name': product.value.name + product.value.subtitle.short,
                                        'brand': product.value.manufacture,
                                        'price': product.value.price,
                                        'coupon': 'продукт тест',
                                    },
                                ],
                            },
                        },
                    });
                } catch {
                }
            } catch (error) {
                $q.notify({
                    color: 'negative',
                    message: error.message,
                });
            }
        };

        // добавление товара в корзину
        const addToCart = async () => {
            userAuthorized.value
                ? await putProductInCart()
                : await putProductInLocalCart();
            try {
                ym(72234883, 'reachGoal', 'klik-korzina');

                window.dataLayer.push({
                    'ecommerce': {
                        'currencyCode': 'RUB',
                        'add': {
                            'products': [
                                {
                                    'id': product.value.id,
                                    'name': product.value.name + product.value.subtitleShort,
                                    'brand': product.value.manufacture,
                                    'price': product.value.price,
                                    'coupon': 'продукт тест',
                                },
                            ],
                        },
                    },
                });
            } catch {
            }
        };

        // добавление товара в корзину для авторизоаванных
        const putProductInCart = async () => {
            loading.value = true;
            const in_basket = false;

            if (amount.value && amount.value > 0) {
                try {
                    await store.dispatch('basketNew/PUT_PRODUCT_IN_BUSKET', {
                        product: {
                            id: product.value.id,
                            amount: amount.value,
                            checked: true,
                        },
                        in_basket,
                    });

                    inCart.value = true;
                } catch (error) {
                    $q.notify({
                        color: 'negative',
                        message: 'Произошла ошибка. Повторите попытку позже',
                    });
                }
            }

            loading.value = false;
        };

        const putProductInLocalCart = async (id = product.value.url) => {
            loading.value = true;
            const payload = await store.dispatch('products/GET_PRODUCT_BY_SLUG', {id});
            //Сохранение в IndexDB
            await store.dispatch('localStorage/SAVE_LOCAL_DATA', payload);

            //store.commit('localStorage/ADD_TO_CART', payload);

            inCart.value = true;

            loading.value = false;

        };

        // переход в корзину
        const goToCart = () => {
            router.push(city.value ? `/${city.value.slug}/basket` : '/basket');
        };

        const goToMarketing = (sale) => {
            router.push(city.value ? `/${city.value.slug}/marketing/${sale.advertisment_id}` : `/basket/marketing/${sale.advertisment_id}`);
        };

        // генерация хлебных крошек
        const setCrumbPath = async () => {
            routeObj.length = 0;
            let arr = [];

            if (product.value.groupCategory)
                arr.push(JSON.parse(JSON.stringify(product.value.groupCategory)));
            if (product.value.category)
                arr.push(JSON.parse(JSON.stringify(product.value.category)));
            if (product.value.subCategory)
                arr.push(JSON.parse(JSON.stringify(product.value.subCategory)));

            for (let i = 0; i < arr.length; i++) {
                let item = arr[i];
                routeObj.push({
                    title: item.title,
                    link: `${city.value ? '/' + city.value.slug : ''}/catalog/${item.url}`,
                });
            }

            routeObj.push({
                title: product.value.name,
                link: '',
            });
        };

        // // добавление/удаление из избранного
        const updateFavourite = async () => {
            if (isFavourite.value) {
                userAuthorized.value
                    ? deleteProductFromUserFav()
                    : await store.dispatch('localStorage/DELETE_FAVOURITE_PRODUCT', product.value.id);
            } else {
                userAuthorized.value
                    ? addProductToUserFav()
                    : await store.dispatch('localStorage/ADD_FAVOURITE_PRODUCT', product.value.id);
            }
        };

        const deleteProductFromUserFav = async () => {
            try {
                await store.dispatch('user/DELETE_FAVOURITE_PRODUCT', product.value.id);
                await store.commit('user/DELETE_USER_FAVOURITE_PRODUCT', product.value.id);
                isLocalFavourite.value = false;
            } catch (e) {
                isLocalFavourite.value = true;
            }
        };

        const addProductToUserFav = async () => {
            try {
                await store.dispatch('user/ADD_FAVOURITE_PRODUCT', product.value.id);
                isLocalFavourite.value = true;
            } catch (e) {
                isLocalFavourite.value = false;
            }
        };

        // изменение кол-ва товара
        const setAmount = async (pm) => {
            if (pm) {
                amount.value++;
            } else {
                if (!(amount.value - 1) || amount.value - 1 < 0) {
                    userAuthorized.value
                        ? await delProductInCart()
                        : await store.dispatch('localStorage/DELETE_ITEM', product.value.id);
                    amount.value = 1;
                    inCart.value = false;
                    return;
                } else {
                    amount.value--;
                }
            }


            if (userAuthorized.value) {
                /**
                 * Если пользователь авторизован
                 * ставим задержку на отправку данных о количестве товара в корзине в 1 сек.
                 */

                if (amountTimer.value) {
                    clearTimeout(amountTimer.value);
                }
                amountTimer.value = setTimeout(await putProductInCart, 300);
            } else {
                // если пользователь НЕ авторизован
                // сохраняем кол-во товара локально в браузере
                await store.dispatch('localStorage/UPDATE_LOCAL_DATA', {
                    id: product.value.id,
                    amount: amount.value,
                });

                // store.commit('localStorage/SET_AMOUNT', {
                //     id: product.value.id,
                //     amount: amount.value,
                // });
            }
        };

        const getCount = (array) => {
            let is_stock = 0;
            let is_preorder = 0;

            array.forEach((item) => {
                if (item.is_stock) {
                    is_stock += 1;
                }

                if (item.is_preorder) {
                    is_preorder += 1;
                }
            });

            return {
                is_stock,
                is_preorder,
                sum: is_stock + is_preorder,
            };
        };

        const calcToProduct = ({inventoryList, amount, preorder}) => {
            const localInventories = {};

            if (!notAvailable.value)
                inventoryList
                    .forEach(({id, drugstoreBalance}) => {
                        if (drugstoreBalance >= amount) {
                            localInventories[drugstoreId] = {
                                is_stock: true,
                                is_preorder: false,
                            };
                        } else if (preorder?.preorderBalance >= amount) {
                            localInventories[drugstoreId] = {
                                is_stock: false,
                                is_preorder: true,
                            };
                        } else {
                            localInventories[drugstoreId] = {
                                is_stock: false,
                                is_preorder: false,
                            };
                        }
                    });

            return localInventories;
        };

        const generateInventories = () => {
            if (product.value) {
                const localInventories = {};

                [{...product.value, amount: amount.value}]
                    .forEach((product) => {
                        Object.entries(calcToProduct(product))
                            .forEach(([key, value]) => {
                                if (localInventories[key] === undefined) {
                                    localInventories[key] = [];
                                }

                                localInventories[key].push(value);
                            });
                    });

                Object.entries(localInventories)
                    .forEach(([key, value]) => {
                        const count = getCount(value);
                        const total = count.sum;

                        localInventories[key] = [];

                        if (count.is_stock) {
                            const label = count.is_stock !== 1
                                ? `в наличии ${count.is_stock} шт.`
                                : 'в наличии';

                            localInventories[key].push({
                                color: 'positive',
                                label,
                            });

                            if (total === 0) {
                                localInventories[key].available = true;

                                return;
                            } else {
                                localInventories[key].available = false;
                            }
                        }

                        if (count.is_preorder) {
                            const label = count.is_preorder !== 1
                                ? `заказать со склада ${count.is_preorder} шт.`
                                : 'заказать со склада';

                            localInventories[key].push({
                                color: 'positive',
                                label,
                            });
                        }

                        if (count.sum !== 1) {
                            const label = total > 0
                                ? `нет в наличии ${total} шт.`
                                : 'нет в наличии';

                            localInventories[key].push({
                                color: 'negative',
                                label,
                            });
                        }
                    });

                inventories.value = localInventories;
            }
        };

        const preventAmoutUp = computed(() => {
            if (product.value.limit < 0) {
                return amount.value >= product.value.totalCount;
            } else if (product.value.limit == 0 || product.value.pku) {
                return false;
            } else if (product.value.limit > 0) {
                return amount.value >= product.value.limit;
            }
            return false;
        });

        // вычисление количества ревью
        const reviews = computed(() => {
            return null;
        });

        const showReviewForm = async () => {
            reviewForm.value = true;

            try {
                ym(72234883, 'reachGoal', 'klik-otzyv');
            } catch {
            }
        };

        const closeReviewForm = async () => {
            reviewForm.value = false;
        };

        // вомзожна ли бесплатная доставка
        const freeDelivery = computed(() => {
            return product.value.delivery && (!product.value.isPrescription || product.value.isErp);
        });

        // возможна ли доставка
        const delivery = computed(() => {
            return !product.value.isPrescription || product.value.isErp;
        });

        const freeDeliveryOne = computed(() => {
            return product.value.delivery == 1 && (!product.value.isPrescription || product.value.isErp);
        });

        const freeDeliveryTwo = computed(() => {
            return product.value.delivery == 2 && (!product.value.isPrescription || product.value.isErp);
        });


        // рассчёт даты получения товара от поставщика
        const plannedDate = computed(() => {
            // если у поставщика нет товара
            if (!product.value.preorder?.preorder_balance)
                return;

            let distantDate = new Date(product.value.preorder?.preorder_supply_date);

            if (new Date() > distantDate) {
                return new Date(product.value.preorder?.preorder_next_supply_date).toLocaleDateString();
            } else {
                return new Date(distantDate).toLocaleDateString();
            }
        });

        const subscribeProduct = async () => {
            if (!userAuthorized.value) {
                subscribe.value = false;
                showAuth();
            } else {
                if (!userEmail.value) {
                    subscribe.value = false;
                    $q.notify({
                        color: 'negative',
                        message: 'Для получения уведомлений укажите e-mail в профиле',
                    });
                } else {
                    try {
                        await store.dispatch('user/ADD_SUBSCRIPTION', product.value.id);
                        $q.notify({
                            color: 'positive',
                            message: 'Ожидайте уведомление о поступлении товара на электронную почту',
                        });
                        try {
                            ym(72234883, 'reachGoal', 'klik-postuplenie');
                        } catch {
                        }
                    } catch (error) {
                        $q.notify({
                            color: 'negative',
                            message: 'Произошла ошибка. Повторите попытку позже',
                        });
                    }
                    ;
                }
            }
        };

        const unSubscribeProduct = async () => {
            if (userAuthorized.value) {
                try {
                    await store.dispatch('user/DELETE_SUBSCRIPTION', product.value.id);
                } catch (error) {
                    $q.notify({
                        color: 'negative',
                        message: 'Произошла ошибка. Повторите попытку позже',
                    });
                }
                ;
            }
        };

        watch(subscribe, () => {
            subscribe.value ? subscribeProduct() : unSubscribeProduct();
        });

        const userSubscribtions = computed(() => store.getters['user/USER_SUBSCRIPTIONS']);

        const isSubscribe = computed(() => {
            const subscribtions = userSubscribtions.value;
            return subscribtions?.find((item) => item === product.value.id);
        });

        const showAuth = () => {
            store.commit('auth/SET_ENTRY_AUTH', 'signin');
        };

        const userEmail = computed(() => store.getters['user/USER_EMAIL']);

        const scrollTo = (id, isInstruction = false) => {
            if (isInstruction) activeInstruction.value = id;
            if (id == 'instruction') {
                isOpenDescription.value = true;

                if (product.value.description.find((item) => item.title == 'Показания к применению')) {
                    abs('Показания к применению');
                    return;
                }
            }

            const element = document.getElementById(id);
            const yOffset = -320;
            const topY = element?.getBoundingClientRect().top + window.scrollY + yOffset;
            const bottomY = element?.getBoundingClientRect().bottom + window.scrollY + yOffset;
            window.scrollTo({behavior: 'smooth', top: topY});
        };

        const anchorLinks = computed(() => [{
            label: 'Основное',
            value: 'overall',
            condition: true,
        }, {
            label: 'Рекомендации',
            value: 'additional',
            condition: additionalSales.value?.length,
        }, {
            label: 'Аналоги',
            value: 'analogs',
            condition: productAnalogs.value?.length,
        }, {
            label: 'Инструкция',
            value: 'instruction',
            condition: description.value,
        }, {
            label: 'Форма',
            value: 'formfactor',
            condition: formFactor.value?.length,
        }, {
            label: 'Отзывы',
            value: 'reviews',
            condition: true,
        }, {
            label: 'Наличие',
            value: 'drugstores',
            condition: drugstores.value && !notAvailable.value,
        }]);

        const goAnchor = () => {
            if (scrollY < 130) {
                if (showAnchor.value === true) {
                    showAnchor.value = false;
                }
            } else {
                if (showAnchor.value === false) {
                    showAnchor.value = true;
                }
            }
        };

        const drugstoresTodayText = computed(() => {
            if (product.value.qDs > 4 && product.value.qDs < 20 || product.value.qDs % 10 >= 5 && product.value.qDs % 10 <= 9 || product.value.qDs % 10 == 0)
                return 'аптеках';
            if (product.value.qDs === 1 || product.value.qDs % 10 == 1)
                return 'аптеке';
            return 'аптеках';
        });

        const drugstoresPreorderText = computed(() => {
            let n = drugstoresCount.value.length;

            if (n > 4 && n < 20 || n % 10 >= 5 && n % 10 <= 9 || n % 10 == 0)
                return 'аптеках';
            if (n === 1 || n % 10 == 1)
                return 'аптеке';
            return 'аптеках';
        });

        const orthopedicsDrugstoresPreorderText = computed(() => {
            let n = orthopedicsDrugstores.value.length;

            if (n > 4 && n < 20 || n % 10 >= 5 && n % 10 <= 9 || n % 10 == 0)
                return 'аптеках';
            if (n === 1 || n % 10 == 1)
                return 'аптеке';
            return 'аптеках';
        });

        const opticsDrugstoresPreorderText = computed(() => {
            let n = opticsDrugstores.value.length;

            if (n > 4 && n < 20 || n % 10 >= 5 && n % 10 <= 9 || n % 10 == 0)
                return 'аптеках';
            if (n === 1 || n % 10 == 1)
                return 'аптеке';
            return 'аптеках';
        });

        const drugstoresAllNightText = computed(() => {
            let n = allNightDrugstores.value.length;

            if (n > 1 && n < 21 || n % 10 != 1)
                return 'аптеках';

            return 'аптекe';
        });

        const activeInstruction = ref(null);

        const anchorCheck = () => {

            const yOffset = -250;

            const overall = document.getElementById('overall');
            const overallY = overall?.getBoundingClientRect().top + window.scrollY + yOffset;
            const overallX = overall?.getBoundingClientRect().bottom + window.scrollY + yOffset;

            if (scrollY > overallY && scrollY < overallX) {
                overallAnchor.value = 'overallAnchor';
            } else {
                overallAnchor.value = '';
            }

            const additional = document.getElementById('additional');
            const additionalY = additional?.getBoundingClientRect().top + window.scrollY + yOffset;
            const additionalX = additional?.getBoundingClientRect().bottom + window.scrollY + yOffset;

            if (scrollY > additionalY && scrollY < additionalX) {
                additionalAnchor.value = 'additionalAnchor';
            } else {
                additionalAnchor.value = '';
            }

            const analogs = document.getElementById('analogs');
            const analogsY = analogs?.getBoundingClientRect().top + window.scrollY + yOffset;
            const analogsX = analogs?.getBoundingClientRect().bottom + window.scrollY + yOffset;

            if (scrollY > analogsY && scrollY < analogsX) {
                analogsAnchor.value = 'analogsAnchor';
            } else {
                analogsAnchor.value = '';
            }

            const instruction = document.getElementById('instruction');
            const instructionY = instruction?.getBoundingClientRect().top + window.scrollY + yOffset;
            const instructionX = instruction?.getBoundingClientRect().bottom + window.scrollY + yOffset;

            if (scrollY > instructionY && scrollY < instructionX) {
                instructionAnchor.value = 'instructionAnchor';
            } else {
                instructionAnchor.value = '';
            }

            const formfactor = document.getElementById('formfactor');
            const formfactorY = formfactor?.getBoundingClientRect().top + window.scrollY + yOffset;
            const formfactorX = formfactor?.getBoundingClientRect().bottom + window.scrollY + yOffset;

            if (scrollY > formfactorY && scrollY < formfactorX) {
                formfactorAnchor.value = 'formfactorAnchor';
            } else {
                formfactorAnchor.value = '';
            }

            const reviews = document.getElementById('reviews');
            const reviewsY = reviews?.getBoundingClientRect().top + window.scrollY + yOffset;
            const reviewsX = reviews?.getBoundingClientRect().bottom + window.scrollY + yOffset;

            if (scrollY > reviewsY && scrollY < reviewsX) {
                reviewsAnchor.value = 'reviewsAnchor';
            } else {
                reviewsAnchor.value = '';
            }

            const drugstores = document.getElementById('drugstores');
            const drugstoresY = drugstores?.getBoundingClientRect().top + window.scrollY + yOffset;
            const drugstoresX = drugstores?.getBoundingClientRect().bottom + window.scrollY + yOffset;

            if (scrollY > drugstoresY && scrollY < drugstoresX) {
                drugstoresAnchor.value = 'drugstoresAnchor';
            } else {
                drugstoresAnchor.value = '';
            }
        };

        const checkHeight = () => {
            if (!notAvailable.value) {
                imgHeight.value = 400;
                return;
            }

            const overall = document.getElementById('overall');
            imgHeight.value = overall?.offsetHeight;
            imgHeight.value -= 56;
        };

        watch(product, () => {
            currentDrugstoreFilter.value = null;
            drugstoresCard.value = false;
            filteredDrugstores.value = [];
            allNightDrugstores.value = [];
            checkHeight();
            if (!userAuthorized.value) {
                checkLocalBasket();
            } else {
                checkProdInBasket();
            }
            setCrumbPath();
        });

        const scrollToDrugstores = () => {
            scrollTo('drugstores');
            drugstoresCard.value = false;
        };

        const goTo = (url) => {
            router.push(`${url}`);
        };

        const checkLocalBasket = () => {

            let localProd = cartProducts.value?.find((item) => item.id === product.value.id);

            if (localProd) {
                amount.value = localProd.amount;
                inCart.value = true;
            } else {
                amount.value = 1;
                inCart.value = false;
            }
        };

        const checkProdInBasket = () => {
            if (product.value.inBasket) {
                amount.value = product.value.inBasket;
                inCart.value = true;
            } else {
                amount.value = 1;
                inCart.value = false;
            }
        };

        const shares = computed(() => [{
            title: 'ВКонтакте',
            icon: 'vk-round',
            link: `http://vk.com/share.php?url=https://etabl.ru/product/${product.value.url}&title=${product.value.name} ${product.value.subtitleShort}&description=${product.value.subtitleShort}&image=${product.value.previewImage}&noparse=true`,
        }, {
            title: 'Одноклассники',
            icon: 'ok-round',
            link: `https://connect.ok.ru/offer?url=https://etabl.ru/product/${product.value.url}`,
        }, {
            title: 'Telegram',
            icon: 'telegram',
            link: `https://t.me/share/url?url=https://etabl.ru/product/${product.value.url}&text=${product.value.name} ${product.value.subtitleShort}`,
        }, {
            title: 'WhatsApp',
            icon: 'whats-app',
            link: `https://api.whatsapp.com/send?text=${product.value.name} ${product.value.subtitleShort} https://etabl.ru/product/${product.value.url}`,
        }]);

        const copy = async () => {
            copyToClipboard(`https://etabl.ru/product/${product.value.url}`);
            $q.notify({
                color: 'positive',
                message: 'Ссылка скопирована',
            });
            showShares.value = false;
        };

        const fastBuy = async () => {
            if (!inCart.value) {
                userAuthorized.value ? await putProductInCart() : await putProductInLocalCart;
            }

            goToCart();
        };

        const productRating = computed(() => {
            let rating = 0;

            product.value.reviews.forEach((item) => rating += item.rating);

            return (rating / product.value.reviews.length).toFixed(1);
        });

        const productRatingRound = computed(() => Math.round(+productRating.value));

        const openWindow = (value) => {
            let link = city.value ? `/${city.value.slug}${value}` : `${value}`;
            if (process.env.CLIENT)
                window.open(link, '_blank');
        };

        watch(() => cartProducts.value, () => {
            if (!userAuthorized.value) {
                let localProd = cartProducts.value?.find((item) => item.id === product.value.id);

                if (localProd) {
                    amount.value = localProd.amount;
                    inCart.value = true;
                } else {
                    amount.value = 1;
                    inCart.value = false;
                }
            }
        });
        watch(() => product.value, (value, oldValue, onCleanup) => {
            if (process.env.CLIENT)
                console.log(value, oldValue);
        });
        watch(() => city.value, (value, oldValue, onCleanup) => {
            setCrumbPath();

        });

        onMounted(async () => {
            if (!userAuthorized.value) {
                checkLocalBasket();
            } else {
                checkProdInBasket();
            }

            if (product.value.isFavourite)
                isLocalFavourite.value = true;
            drugstoreList.value = false;
            await setCrumbPath();
            generateInventories();

            if (!isSubscribe.value && notAvailable.value) {
                subscribe.value = false;
            }

            if (userAuthorized.value)
                await store.dispatch('advertisement/GET_HISTORY');


            if (process.env.CLIENT) {
                window.addEventListener('scroll', goAnchor);
                window.addEventListener('scroll', anchorCheck);
            }

            checkHeight();

            try {
                window.dataLayer.push({
                    'ecommerce': {
                        'currencyCode': 'RUB',
                        'detail': {
                            'products': [
                                {
                                    'id': product.value.id,
                                    'name': product.value.name + product.value.subtitleShort,
                                    'brand': product.value.manufacture,
                                    'price': product.value.price,
                                    'category': product.value.type,
                                },
                            ],
                        },
                    },
                });
            } catch {
            }
        });

        return {
            promotionNameplate,
            abs,
            routeObj,
            product,
            notAvailable,
            loading,
            inCart,
            isFavourite,
            updateFavourite,
            productAnalogs,
            addToCart,
            fixedMenu,
            goToCart,
            amount,
            setAmount,
            description,
            currentCharact,
            formFactor,
            drugstores,
            openImg,
            reviewForm,
            preventAmoutUp,
            showAllReviews,
            reviews,
            email,
            name,
            salePercent,
            drugstoreList,
            delivery,
            freeDelivery,
            plannedDate,
            showReviewForm,
            subscribeProduct,
            subscribe,
            isOpenDescription,
            userSubscribtions,
            isSubscribe,
            unSubscribeProduct,
            showAuth,
            userAuthorized,
            userEmail,
            scrollTo,
            anchorLinks,
            showAnchor,
            overallAnchor,
            analogsAnchor,
            instructionAnchor,
            formfactorAnchor,
            reviewsAnchor,
            drugstoresAnchor,
            additionalAnchor,
            drugstoresTodayText,
            drugstoresPreorderText,
            history,
            additionalSales,
            isOrthopedics,
            isOptics,
            orthopedicsDrugstores,
            orthopedicsDrugstoresPreorderText,
            imgHeight,
            allNightDrugstores,
            drugstoresAllNightText,
            freeDeliveryOne,
            freeDeliveryTwo,
            filteredDrugstores,
            currentDrugstoreFilter,
            drugstoresCard,
            showDrugstoresCard,
            scrollToDrugstores,
            isLocalFavourite,
            deleteProductFromUserFav,
            addProductToUserFav,
            goTo,
            checkLocalBasket,
            checkProdInBasket,
            shares,
            copy,
            showShares,
            fastBuy,
            city,
            isActivAccessibility,
            drugstoresCount,
            opticsDrugstores,
            opticsDrugstoresPreorderText,
            closeReviewForm,
            productRating,
            productRatingRound,
            userAddress,
            windowWidth,
            openWindow,
            showErpTooltip,
            showPrecriptionTooltip,
            showTermoTooltip,
            termoText,
            activeInstruction,
            goToMarketing,
            cartProducts,
        };
    },
};
</script>

<style lang="scss" scoped>
span {
    &#name {
        display: block !important;
        max-height: 40px;
        overflow: hidden;
        white-space: pre-line;
        max-width: 100%;
        text-overflow: ellipsis;
        position: relative;
        line-height: 20px;
    }
}

.product {
    &__title {

        flex-direction: row;
        display: flex;

        font: {
            size: 24px;
            //weight: 600;
        }

        line-height: 28px;
        max-width: 80%;
    }

    &__amount {
        height: 40px;
        border-radius: 20px;
        border: 0;
        background-color: $positive;
        padding: 3px;
        color: $secondary;
        outline: none;

        font: {
            size: 16px;
            weight: 600;
        }

        & > span {
            flex-grow: 1;
            text-align: center;
            margin-top: -2px;
        }
    }

    &__counter {
        border-radius: 20px;
        overflow: hidden;
        color: $primary;
        height: 36px;
        bottom: 1px;
        position: relative;

        font: {
            size: 12px;
            weight: 500;
        }
    }

    &__count {
        width: 36px;
        background-color: $app-color-background;

        @media screen and (max-width: 1280px) {
            width: 30px;
        }
    }

    &__button {
        width: 36px;
        background-color: $accent;
        color: $primary;
        text-transform: none;
        border-radius: 0;
        min-height: 36px;
        padding-top: 2px;

        font: {
            weight: 600;
        }

        &__disable {
            color: $medium-gray;
        }

        @media screen and (max-width: 1280px) {
            width: 30px;
        }
    }

    & .custom-a-top-left {
        top: 15px;
        left: 15px;
        z-index: 1;
    }
}

.navigation-block {
    border-bottom: 1px solid $light-gray;
    margin-top: 32px;

    &-fixed {
        width: 100%;
        position: fixed;
        z-index: 2000;
        left: 0;
        margin: 0;
        background-color: $secondary;
    }

    &__bar {
        &-item {
            color: $positive;
            text-decoration: none;
            text-transform: uppercase;
            line-height: 22px;
            padding-bottom: 6px;

            font: {
                size: 16px;
                weight: 600;
            }

            &:hover {
                cursor: pointer;

                &::after {
                    content: "";
                    position: absolute;
                    left: 0;
                    bottom: -1px;
                    width: 100%;
                    height: 2px;
                    background-color: $positive;
                }
            }
        }
    }
}

.stock {
    margin: 24px 0 39px;

    &__item {
        line-height: 16px;
        color: $primary;
        padding: 3px 9px;
        border-radius: 4px;
        margin-right: 25px;

        font: {
            size: 14px;
            weight: 400;
        }

        &-yellow {
            border: 1px solid $stock;
            background-color: $stock;
        }

        &-green {
            border: 1px solid $positive;
        }
    }
}

.card-product {
    &__img {

        & img {
            max-width: 100%;
            max-height: 400px;
            display: block;
            margin: 0 auto;
        }

        & div {
            color: $medium-gray;
            line-height: 16px;

            font: {
                size: 12px;
                weight: 400;
            }

            @media (max-width: 1280px) {
                font-size: 12px;
            }
            @media (max-width: 960px) {
                font-size: 10px;
            }
        }
    }

    &__characteristics {
        padding: 0 40px;

        &-info {
            line-height: 16px;
            margin-bottom: 16px;
            margin-bottom: 16px;
            font: {
                size: 14px;
                weight: 400;
            }
            margin-bottom: 16px;
            font: {
                size: 14px;
                weight: 400;
            }

            @media (max-width: 1280px) {
                font-size: 12px !important;
            }

            & span:first-of-type {
                color: $grey-9;
            }

            & span:last-of-type {
                color: $primary;
            }
        }

        &-line {
            flex-grow: 1;
            height: 1em;
            border-bottom: 1px solid $accent;
            margin: 0 5px;
        }
    }

    &__show-more {
        border: 0;
        border-bottom: 1px dotted $positive;
        outline: none;
        background-color: inherit;
        padding: 0 0 6px 0;
        line-height: 19px;
        color: $positive;

        font: {
            size: 16px;
            weight: 400;
        }

        &:hover {
            cursor: pointer;
        }
    }

    &__price-info {
        border-radius: 10px;
        box-shadow: 0px 7px 20px rgba(53, 53, 53, 0.3);
        padding: 12px 16px 24px;

        @media (max-width: 1280px) {
            padding: 12px 20px 24px;
        }
    }

    &__price {
        color: $primary;
        line-height: 35px;

        font: {
            size: 26px;
            weight: 600;
        }

        & > span {

            @media (max-width: 1280px) {
                font-size: 14px;
            }
        }
    }

    &__button {
        width: 100%;
        height: 40px;
        background-color: $positive;
        border-radius: 27px;
        line-height: 22px;
        color: $app-text-secondary;
        margin: 18px 0 20px;
        text-transform: none;

        font: {
            size: 16px;
            weight: 700;
        }

        &:hover {
            cursor: pointer;
        }
    }

    &__availability {
        color: $positive;
        line-height: 22px;

        font: {
            size: 16px;
            weight: 400;
        }

        @media (max-width: 960px) {
            font-size: 14px;
        }
    }

    &__frost-icon {
        color: $light-blue !important;
    }

    &__warning-icon {
        color: $negative !important;
    }

    &__additional {
        &-item {
            margin-bottom: 18px;

            &:first-of-type {
                margin-top: 12px;
            }

            & span {
                line-height: 16px;
                color: $primary;
                padding-left: 10px;

                font: {
                    size: 14px;
                    weight: 400;
                }
            }
        }
    }

    &__disable {
        z-index: 1;
        background: #fff6;
        width: 40%;
        max-width: 400px;
        position: absolute;
        max-height: 400px;
    }

}

.analogs {
    margin: 25px 0 16px;

    p {
        @media (max-width: 1280px) {
            font-size: 20px !important;
        }
        @media (max-width: 960px) {
            font-size: 18px !important;
        }
    }
}

.instruction {
    &__title {
        color: $primary;
        line-height: 62px;
        margin: 0;

        font: {
            size: 32px;
            weight: 700;
        }

        @media (max-width: 960px) {
            font-size: 18px;
        }
    }

    &__items {
        margin: 12px 0 24px;
    }

    &__item {
        font-size: 16px;
        color: $primary;
        font-weight: 400;
        line-height: 20px;
        display: inline-block;
        margin-right: 16px;
        margin-bottom: 10px;
        text-decoration: none;
        border-bottom: 1px solid $gray;

        &-active {
            color: $positive;
            border-bottom: 1px solid $positive;
        }

        &:hover {
            cursor: pointer;
            color: $positive;
            border-bottom: 1px solid $positive;
            //font-weight: 600;
        }
    }
}

.modal-map {
    &__body {
        max-width: 100% !important;
        width: 90vw !important;
        height: 90vh !important;
    }
}

.modal-preview {
    padding: 25px !important;

    &__close-img {
        top: 10px;
        right: 10px;
    }
}

.fav-button {
    z-index: 2;
    transition: $main-transition;
    //height: 40px;
    border-radius: 20px;
    //width: 40px;
    //background: $grey-5;

    &:hover {
        transform: scale(1.1);
    }
}

.reviews {
    background: $secondary;
    border-radius: 20px;
}

.review-form {
    padding: 36px 90px;
    width: 784px;
    max-width: 100%;
}

textarea {
    border-radius: 16px;
    height: 150px;
    background: $secondary !important;
    outline: none;
    border: 0;
    box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.1);
    padding: 10px;
    color: $app-text-primaty;

    font: {
        size: 14px;
    }
}

.q-input {
    width: 50%;
    height: 46px;
    padding-bottom: 0 !important;

    :deep(.q-field__native::placeholder) {
        color: #ACACAC;
    }

    :deep(.q-field__inner) {
        border-radius: 16px;
        box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.1);
    }

    :deep(.q-field__control) {
        border-radius: 16px;
        height: 46px;
    }

    :deep(.q-field__control:before) {
        border: 0 !important;
    }

    :deep(.q-field__control:after) {
        border-width: 1px !important;
    }
}

.review-complite {
    line-height: 22px;
    padding: 84px 78px;
    width: 544px;
    height: 214px;
}

.text-gray {
    color: #939393;
}

.anchor-text {
    margin-right: 64px;

    @media screen and (max-width: 1440px) {
        margin-right: 0;
    }
}

.bottom-line {
    border-bottom: 1px solid $positive !important;
}

.anchors-top {
    @media screen and (max-width: 1440px) {
        justify-content: space-between;
    }
}

.anchor-block {
    padding-top: 48px;
    z-index: 1000;
    width: 100%;
    height: 160px;
    position: fixed;
    top: 75px;
    background: $secondary;
    border-bottom: 1px solid #D2D2D2;
    border-radius: 0 0 10px 10px;
    padding-left: calc((100% - 1310px) / 2 + 16px);
    padding-right: calc((100% - 1310px) / 2 + 16px);

    @media screen and (max-width: 1440px) {
        justify-content: space-between;
        padding-left: calc((100% - 1240px) / 2 + 16px);
        padding-right: calc((100% - 1240px) / 2 + 16px);
    }

    @media screen and (max-width: 1280px) {
        padding-left: calc((100% - 926px) / 2 + 16px);
        padding-right: calc((100% - 926px) / 2 + 16px);
    }
}

.additional {
    background: #E2F0E8;
    border-radius: 16px;
    overflow: hidden;
    //height: 184px;
}

.justify-text {
    text-align: justify;
}

.drugstores-card {
    width: 700px;
    height: 436px;
    border-radius: 26px;
    position: absolute;
    z-index: 99;
    right: 0px;
}

.package-form {
    padding-top: 9px;
    border: 1px solid $grey-14;
    text-decoration: none;
}

.active-form {
    background: $positive;
    color: $secondary !important;
    border: none;
}

.top-anchors {
    height: 56px;
}

.share {
    z-index: 3;
    position: absolute;
    right: 16px;
}

.erp-card {
    position: absolute;
    bottom: 24px;
}
</style>
